export const DictionaryIllustrator_zh_TW = [
    {
        id: 18,
        label: '編輯 > 貼至上層',
        placement: 'MenuBar',
        name: '貼至上層',
    },
    {
        id: 19,
        label: '編輯 > 貼至下層',
        placement: 'MenuBar',
        name: '貼至下層',
    },
    {
        id: 20,
        label: '檔案 > 從範本新增...',
        placement: 'MenuBar',
        name: '從範本新增...',
    },
    {
        id: 22,
        label: '物件 > 變形 > 再次變形',
        placement: 'MenuBar',
        name: '再次變形',
    },
    {
        id: 23,
        label: '物件 > 組成群組',
        placement: 'MenuBar',
        name: '組成群組',
    },
    {
        id: 24,
        label: '物件 > 解散群組',
        placement: 'MenuBar',
        name: '解散群組',
    },
    {
        id: 25,
        label: '物件 > 路徑 > 接合',
        placement: 'MenuBar',
        name: '接合',
    },
    {
        id: 26,
        label: '物件 > 路徑 > 平均...',
        placement: 'MenuBar',
        name: '平均...',
    },
    {
        id: 28,
        label: '物件 > 鎖定 > 選取範圍',
        placement: 'MenuBar',
        name: '選取範圍',
    },
    {
        id: 29,
        label: '物件 > 全部解除鎖定',
        placement: 'MenuBar',
        name: '全部解除鎖定',
    },
    {
        id: 30,
        label: '檢視 > 預視',
        placement: 'MenuBar',
        name: '預視',
    },
    {
        id: 33,
        label: '檢視 > 像素預視',
        placement: 'MenuBar',
        name: '像素預視',
    },
    {
        id: 34,
        label: '文字 > 區域文字選項...',
        placement: 'MenuBar',
        name: '區域文字選項...',
    },
    {
        id: 35,
        label: '檢視 > 使工作區域符合視窗',
        placement: 'MenuBar',
        name: '使工作區域符合視窗',
    },
    {
        id: 36,
        label: '視窗 > 新增視窗',
        placement: 'MenuBar',
        name: '新增視窗',
    },
    {
        id: 37,
        label: '檢視 > 尺標 > 顯示尺標',
        placement: 'MenuBar',
        name: '顯示尺標',
    },
    {
        id: 38,
        label: '文字 > 路徑文字 > 3D 帶狀效果',
        placement: 'MenuBar',
        name: '3D 帶狀效果',
    },
    {
        id: 40,
        label: '文字 > 路徑文字 > 階梯效果',
        placement: 'MenuBar',
        name: '階梯效果',
    },
    {
        id: 42,
        label: '物件 > 排列順序 > 移至最前',
        placement: 'MenuBar',
        name: '移至最前',
    },
    {
        id: 43,
        label: '物件 > 排列順序 > 移至最後',
        placement: 'MenuBar',
        name: '移至最後',
    },
    {
        id: 48,
        label: '檔案 > 另存範本...',
        placement: 'MenuBar',
        name: '另存範本...',
    },
    {
        id: 50,
        label: '物件 > 隱藏 > 選取範圍',
        placement: 'MenuBar',
        name: '選取範圍',
    },
    {
        id: 51,
        label: '物件 > 顯示全部物件',
        placement: 'MenuBar',
        name: '顯示全部物件',
    },
    {
        id: 52,
        label: '檢視 > 參考線 > 製作參考線',
        placement: 'MenuBar',
        name: '製作參考線',
    },
    {
        id: 53,
        label: '檢視 > 參考線 > 釋放參考線',
        placement: 'MenuBar',
        name: '釋放參考線',
    },
    {
        id: 54,
        label: '物件 > 變形 > 移動...',
        placement: 'MenuBar',
        name: '移動...',
    },
    {
        id: 55,
        label: 'Illustrator > 偏好設定 > 智慧型參考線...',
        placement: 'MenuBar',
        name: '智慧型參考線...',
    },
    {
        id: 56,
        label: '物件 > 複合路徑 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 57,
        label: '物件 > 複合路徑 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 62,
        label: '文字 > 建立外框',
        placement: 'MenuBar',
        name: '建立外框',
    },
    {
        id: 63,
        label: '檢視 > 實際尺寸',
        placement: 'MenuBar',
        name: '實際尺寸',
    },
    {
        id: 74,
        label: '物件 > 圖表 > 類型...',
        placement: 'MenuBar',
        name: '類型...',
    },
    {
        id: 75,
        label: '物件 > 圖表 > 資料...',
        placement: 'MenuBar',
        name: '資料...',
    },
    {
        id: 76,
        label: '物件 > 圖表 > 長條...',
        placement: 'MenuBar',
        name: '長條...',
    },
    {
        id: 77,
        label: '物件 > 圖表 > 設計...',
        placement: 'MenuBar',
        name: '設計...',
    },
    {
        id: 78,
        label: '物件 > 圖表 > 記號...',
        placement: 'MenuBar',
        name: '記號...',
    },
    {
        id: 83,
        label: '文字 > 路徑文字 > 彩虹效果',
        placement: 'MenuBar',
        name: '彩虹效果',
    },
    {
        id: 84,
        label: '檔案 > 文件設定...',
        placement: 'MenuBar',
        name: '文件設定...',
    },
    {
        id: 85,
        label: '檢視 > 隱藏列印並排',
        placement: 'MenuBar',
        name: '隱藏列印並排',
    },
    {
        id: 86,
        label: '檢視 > 隱藏工作區域',
        placement: 'MenuBar',
        name: '隱藏工作區域',
    },
    {
        id: 87,
        label: '文字 > 標題強制對齊',
        placement: 'MenuBar',
        name: '標題強制對齊',
    },
    {
        id: 95,
        label: '檔案 > 儲存拷貝...',
        placement: 'MenuBar',
        name: '儲存拷貝...',
    },
    {
        id: 98,
        label: 'Illustrator > 偏好設定 > 文字...',
        placement: 'MenuBar',
        name: '文字...',
    },
    {
        id: 99,
        label: 'Illustrator > 偏好設定 > 單位...',
        placement: 'MenuBar',
        name: '單位...',
    },
    {
        id: 100,
        label: '物件 > 排列順序 > 置前',
        placement: 'MenuBar',
        name: '置前',
    },
    {
        id: 101,
        label: '物件 > 排列順序 > 置後',
        placement: 'MenuBar',
        name: '置後',
    },
    {
        id: 109,
        label: '視窗 > 排列順序 > 最小化視窗',
        placement: 'MenuBar',
        name: '最小化視窗',
    },
    {
        id: 110,
        label: '視窗 > 排列順序 > 全部移至最前',
        placement: 'MenuBar',
        name: '全部移至最前',
    },
    {
        id: 113,
        label: '檢視 > 參考線 > 清除參考線',
        placement: 'MenuBar',
        name: '清除參考線',
    },
    {
        id: 114,
        label: '檢視 > 顯示範本',
        placement: 'MenuBar',
        name: '顯示範本',
    },
    {
        id: 115,
        label: '文字 > 顯示隱藏字元',
        placement: 'MenuBar',
        name: '顯示隱藏字元',
    },
    {
        id: 116,
        label: '文字 > 路徑文字 > 偏斜效果',
        placement: 'MenuBar',
        name: '偏斜效果',
    },
    {
        id: 117,
        label: '檔案 > 全部關閉',
        placement: 'MenuBar',
        name: '全部關閉',
    },
    {
        id: 119,
        label: '文字 > 路徑文字 > 重力效果',
        placement: 'MenuBar',
        name: '重力效果',
    },
    {
        id: 120,
        label: '物件 > 剪裁遮色片 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 121,
        label: '物件 > 剪裁遮色片 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 123,
        label: '文字 > 路徑文字 > 路徑文字選項...',
        placement: 'MenuBar',
        name: '路徑文字選項...',
    },
    {
        id: 127,
        label: '物件 > 工作區域 > 轉換為工作區域',
        placement: 'MenuBar',
        name: '轉換為工作區域',
    },
    {
        id: 133,
        label: '文字 > 文字緒 > 建立',
        placement: 'MenuBar',
        name: '建立',
    },
    {
        id: 135,
        label: '檢視 > 放大顯示',
        placement: 'MenuBar',
        name: '放大顯示',
    },
    {
        id: 136,
        label: '檢視 > 縮小顯示',
        placement: 'MenuBar',
        name: '縮小顯示',
    },
    {
        id: 139,
        label: '編輯 > 色彩設定...',
        placement: 'MenuBar',
        name: '色彩設定...',
    },
    {
        id: 140,
        label: 'Illustrator > 偏好設定 > 連字...',
        placement: 'MenuBar',
        name: '連字...',
    },
    {
        id: 141,
        label: 'Illustrator > 偏好設定 > 增效模組與暫存磁碟...',
        placement: 'MenuBar',
        name: '增效模組與暫存磁碟...',
    },
    {
        id: 142,
        label: '選取 > 取消選取',
        placement: 'MenuBar',
        name: '取消選取',
    },
    {
        id: 143,
        label: '檢視 > 疊印預視',
        placement: 'MenuBar',
        name: '疊印預視',
    },
    {
        id: 144,
        label: '檢視 > 新增檢視視窗...',
        placement: 'MenuBar',
        name: '新增檢視視窗...',
    },
    {
        id: 145,
        label: '檢視 > 編輯檢視視窗...',
        placement: 'MenuBar',
        name: '編輯檢視視窗...',
    },
    {
        id: 146,
        label: '檢視 > 靠齊控制點',
        placement: 'MenuBar',
        name: '靠齊控制點',
    },
    {
        id: 147,
        label: '檢視 > 隱藏路徑線條',
        placement: 'MenuBar',
        name: '隱藏路徑線條',
    },
    {
        id: 148,
        label: '物件 > 擴充外觀',
        placement: 'MenuBar',
        name: '擴充外觀',
    },
    {
        id: 150,
        label: '檢視 > 顯示文字緒',
        placement: 'MenuBar',
        name: '顯示文字緒',
    },
    {
        id: 154,
        label: '檢視 > 參考線 > 隱藏參考線',
        placement: 'MenuBar',
        name: '隱藏參考線',
    },
    {
        id: 155,
        label: '檢視 > 參考線 > 鎖定參考線',
        placement: 'MenuBar',
        name: '鎖定參考線',
    },
    {
        id: 157,
        label: '文字 > 文字緒 > 釋放選取的文字物件',
        placement: 'MenuBar',
        name: '釋放選取的文字物件',
    },
    {
        id: 158,
        label: '文字 > 文字緒 > 移除文字緒',
        placement: 'MenuBar',
        name: '移除文字緒',
    },
    {
        id: 159,
        label: '檢視 > 顯示格點',
        placement: 'MenuBar',
        name: '顯示格點',
    },
    {
        id: 160,
        label: '檢視 > 靠齊格點',
        placement: 'MenuBar',
        name: '靠齊格點',
    },
    {
        id: 161,
        label: 'Illustrator > 偏好設定 > 參考線及網格...',
        placement: 'MenuBar',
        name: '參考線及網格...',
    },
    {
        id: 162,
        label: '物件 > 變形 > 旋轉...',
        placement: 'MenuBar',
        name: '旋轉...',
    },
    {
        id: 163,
        label: '物件 > 變形 > 縮放...',
        placement: 'MenuBar',
        name: '縮放...',
    },
    {
        id: 164,
        label: '物件 > 變形 > 鏡射...',
        placement: 'MenuBar',
        name: '鏡射...',
    },
    {
        id: 165,
        label: '物件 > 變形 > 傾斜...',
        placement: 'MenuBar',
        name: '傾斜...',
    },
    {
        id: 166,
        label: '視窗 > 排列順序 > 重疊顯示',
        placement: 'MenuBar',
        name: '重疊顯示',
    },
    {
        id: 168,
        label: '視窗 > 排列順序 > 並排顯示',
        placement: 'MenuBar',
        name: '並排顯示',
    },
    {
        id: 202,
        label: '檢視 > 校樣色彩',
        placement: 'MenuBar',
        name: '校樣色彩',
    },
    {
        id: 203,
        label: '編輯 > 指定描述檔...',
        placement: 'MenuBar',
        name: '指定描述檔...',
    },
    {
        id: 204,
        label: '說明 > 教學課程...',
        placement: 'MenuBar',
        name: '教學課程...',
    },
    {
        id: 223,
        label: '檔案 > 文件色彩模式 > CMYK 色彩',
        placement: 'MenuBar',
        name: 'CMYK 色彩',
    },
    {
        id: 224,
        label: '檔案 > 文件色彩模式 > RGB 色彩',
        placement: 'MenuBar',
        name: 'RGB 色彩',
    },
    {
        id: 225,
        label: '檢視 > 校樣設定 > 文件 CMYK:',
        placement: 'MenuBar',
        name: '文件 CMYK:',
    },
    {
        id: 226,
        label: '檢視 > 校樣設定 > 舊版 Macintosh RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: '舊版 Macintosh RGB (Gamma 1.8)',
    },
    {
        id: 227,
        label: '檢視 > 校樣設定 > 網際網路標準 RGB (sRGB)',
        placement: 'MenuBar',
        name: '網際網路標準 RGB (sRGB)',
    },
    {
        id: 228,
        label: '檢視 > 校樣設定 > 螢幕 RGB',
        placement: 'MenuBar',
        name: '螢幕 RGB',
    },
    {
        id: 229,
        label: '文字 > 文字方向 > 水平',
        placement: 'MenuBar',
        name: '水平',
    },
    {
        id: 230,
        label: '文字 > 文字方向 > 垂直',
        placement: 'MenuBar',
        name: '垂直',
    },
    {
        id: 232,
        label: '說明 > 系統資訊...',
        placement: 'MenuBar',
        name: '系統資訊...',
    },
    {
        id: 278,
        label: '文字 > 舊版文字 > 更新所有舊版文字',
        placement: 'MenuBar',
        name: '更新所有舊版文字',
    },
    {
        id: 279,
        label: '文字 > 舊版文字 > 更新選取的舊版文字',
        placement: 'MenuBar',
        name: '更新選取的舊版文字',
    },
    {
        id: 280,
        label: '文字 > 舊版文字 > 隱藏拷貝',
        placement: 'MenuBar',
        name: '隱藏拷貝',
    },
    {
        id: 281,
        label: '文字 > 舊版文字 > 刪除拷貝',
        placement: 'MenuBar',
        name: '刪除拷貝',
    },
    {
        id: 282,
        label: '文字 > 舊版文字 > 選取拷貝',
        placement: 'MenuBar',
        name: '選取拷貝',
    },
    {
        id: 284,
        label: '檢視 > 校樣設定 > 自訂...',
        placement: 'MenuBar',
        name: '自訂...',
    },
    {
        id: 289,
        label: 'Illustrator > 偏好設定 > 選取和錨點顯示...',
        placement: 'MenuBar',
        name: '選取和錨點顯示...',
    },
    {
        id: 292,
        label: '物件 > 剪裁遮色片 > 編輯內容',
        placement: 'MenuBar',
        name: '編輯內容',
    },
    {
        id: 293,
        label: 'Illustrator > 偏好設定 > 使用者介面...',
        placement: 'MenuBar',
        name: '使用者介面...',
    },
    {
        id: 294,
        label: 'Illustrator > 偏好設定 > 切片...',
        placement: 'MenuBar',
        name: '切片...',
    },
    {
        id: 295,
        label: '視窗 > 應用程式框架',
        placement: 'MenuBar',
        name: '應用程式框架',
    },
    {
        id: 296,
        label: '檢視 > 校樣設定 > 色盲 - 紅色色盲類型',
        placement: 'MenuBar',
        name: '色盲 - 紅色色盲類型',
    },
    {
        id: 297,
        label: '檢視 > 校樣設定 > 色盲 - 綠色色盲類型',
        placement: 'MenuBar',
        name: '色盲 - 綠色色盲類型',
    },
    {
        id: 299,
        label: '檢視 > 尺標 > 顯示視訊尺標',
        placement: 'MenuBar',
        name: '顯示視訊尺標',
    },
    {
        id: 301,
        label: '視窗 > 排列順序 > 在視窗中浮動',
        placement: 'MenuBar',
        name: '在視窗中浮動',
    },
    {
        id: 302,
        label: '視窗 > 排列順序 > 全部在視窗中浮動',
        placement: 'MenuBar',
        name: '全部在視窗中浮動',
    },
    {
        id: 303,
        label: '視窗 > 排列順序 > 合併所有視窗',
        placement: 'MenuBar',
        name: '合併所有視窗',
    },
    {
        id: 304,
        label: '視窗 > 應用程式列',
        placement: 'MenuBar',
        name: '應用程式列',
    },
    {
        id: 310,
        label: '文字 > 路徑文字 > 更新舊版路徑文字',
        placement: 'MenuBar',
        name: '更新舊版路徑文字',
    },
    {
        id: 311,
        label: '檢視 > 全部符合視窗',
        placement: 'MenuBar',
        name: '全部符合視窗',
    },
    {
        id: 315,
        label: '編輯 > 就地貼上',
        placement: 'MenuBar',
        name: '就地貼上',
    },
    {
        id: 316,
        label: '編輯 > 在所有工作區域上貼上',
        placement: 'MenuBar',
        name: '在所有工作區域上貼上',
    },
    {
        id: 331,
        label: '文字 > 文字類型轉換',
        placement: 'MenuBar',
        name: '文字類型轉換',
    },
    {
        id: 339,
        label: '編輯 > 我的設定 > 匯出設定...',
        placement: 'MenuBar',
        name: '匯出設定...',
    },
    {
        id: 340,
        label: '編輯 > 我的設定 > 匯入設定...',
        placement: 'MenuBar',
        name: '匯入設定...',
    },
    {
        id: 347,
        label: '檢視 > 使用 GPU 檢視',
        placement: 'MenuBar',
        name: '使用 GPU 檢視',
    },
    {
        id: 351,
        label: '檔案 > 轉存選取範圍...',
        placement: 'MenuBar',
        name: '轉存選取範圍...',
    },
    {
        id: 353,
        label: '檢視 > 靠齊像素',
        placement: 'MenuBar',
        name: '靠齊像素',
    },
    {
        id: 354,
        label: '檔案 > 轉存 > 轉存為螢幕適用...',
        placement: 'MenuBar',
        name: '轉存為螢幕適用...',
    },
    {
        id: 355,
        label: '檔案 > 轉存 > 轉存為...',
        placement: 'MenuBar',
        name: '轉存為...',
    },
    {
        id: 356,
        label: '檔案 > 轉存 > 儲存為網頁用 (舊版)...',
        placement: 'MenuBar',
        name: '儲存為網頁用 (舊版)...',
    },
    {
        id: 368,
        label: '文字 > 插入特殊字元 > 符號 > 項目符號',
        placement: 'MenuBar',
        name: '項目符號',
    },
    {
        id: 369,
        label: '文字 > 插入特殊字元 > 符號 > 版權符號',
        placement: 'MenuBar',
        name: '版權符號',
    },
    {
        id: 370,
        label: '文字 > 插入特殊字元 > 符號 > 省略符號',
        placement: 'MenuBar',
        name: '省略符號',
    },
    {
        id: 371,
        label: '文字 > 插入特殊字元 > 符號 > 段落符號',
        placement: 'MenuBar',
        name: '段落符號',
    },
    {
        id: 372,
        label: '文字 > 插入特殊字元 > 符號 > 註冊商標符號',
        placement: 'MenuBar',
        name: '註冊商標符號',
    },
    {
        id: 373,
        label: '文字 > 插入特殊字元 > 符號 > 分節符號',
        placement: 'MenuBar',
        name: '分節符號',
    },
    {
        id: 374,
        label: '文字 > 插入特殊字元 > 符號 > 商標符號',
        placement: 'MenuBar',
        name: '商標符號',
    },
    {
        id: 375,
        label: '文字 > 插入特殊字元 > 引號 > 左雙引號',
        placement: 'MenuBar',
        name: '左雙引號',
    },
    {
        id: 376,
        label: '文字 > 插入特殊字元 > 引號 > 右雙引號',
        placement: 'MenuBar',
        name: '右雙引號',
    },
    {
        id: 377,
        label: '文字 > 插入特殊字元 > 引號 > 左單引號',
        placement: 'MenuBar',
        name: '左單引號',
    },
    {
        id: 378,
        label: '文字 > 插入特殊字元 > 引號 > 右單引號',
        placement: 'MenuBar',
        name: '右單引號',
    },
    {
        id: 379,
        label: '文字 > 插入特殊字元 > 連字符號和破折號 > 長破折號',
        placement: 'MenuBar',
        name: '長破折號',
    },
    {
        id: 380,
        label: '文字 > 插入特殊字元 > 連字符號和破折號 > 短破折號',
        placement: 'MenuBar',
        name: '短破折號',
    },
    {
        id: 381,
        label: '文字 > 插入特殊字元 > 連字符號和破折號 > 選擇性連字',
        placement: 'MenuBar',
        name: '選擇性連字',
    },
    {
        id: 382,
        label: '文字 > 插入空白字元 > 全形空格',
        placement: 'MenuBar',
        name: '全形空格',
    },
    {
        id: 383,
        label: '文字 > 插入空白字元 > 半形空格',
        placement: 'MenuBar',
        name: '半形空格',
    },
    {
        id: 384,
        label: '文字 > 插入空白字元 > 微間距',
        placement: 'MenuBar',
        name: '微間距',
    },
    {
        id: 385,
        label: '文字 > 插入空白字元 > 薄間距',
        placement: 'MenuBar',
        name: '薄間距',
    },
    {
        id: 386,
        label: '文字 > 插入換行字元 > 強制分行符號',
        placement: 'MenuBar',
        name: '強制分行符號',
    },
    {
        id: 391,
        label: '文字 > 以預留位置文字填滿',
        placement: 'MenuBar',
        name: '以預留位置文字填滿',
    },
    {
        id: 393,
        label: '物件 > 收集以供轉存 > 為單一資產',
        placement: 'MenuBar',
        name: '為單一資產',
    },
    {
        id: 394,
        label: '物件 > 收集以供轉存 > 為多個資產',
        placement: 'MenuBar',
        name: '為多個資產',
    },
    {
        id: 396,
        label: '檢視 > 剪裁視圖',
        placement: 'MenuBar',
        name: '剪裁視圖',
    },
    {
        id: 397,
        label: '檢視 > 簡報模式',
        placement: 'MenuBar',
        name: '簡報模式',
    },
    {
        id: 404,
        label: '檢視 > 螢幕模式 > 正常螢幕模式',
        placement: 'MenuBar',
        name: '正常螢幕模式',
    },
    {
        id: 405,
        label: '檢視 > 螢幕模式 > 含選單列的全螢幕模式',
        placement: 'MenuBar',
        name: '含選單列的全螢幕模式',
    },
    {
        id: 406,
        label: '檢視 > 螢幕模式 > 全螢幕模式',
        placement: 'MenuBar',
        name: '全螢幕模式',
    },
    {
        id: 411,
        label: '檢視 > 靠齊字符',
        placement: 'MenuBar',
        name: '靠齊字符',
    },
    {
        id: 415,
        label: '檢視 > 針對選取範圍旋轉檢視',
        placement: 'MenuBar',
        name: '針對選取範圍旋轉檢視',
    },
    {
        id: 417,
        label: '檢視 > 旋轉檢視 > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: '檢視 > 旋轉檢視 > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: '檢視 > 旋轉檢視 > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: '檢視 > 旋轉檢視 > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: '檢視 > 旋轉檢視 > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: '檢視 > 旋轉檢視 > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: '檢視 > 旋轉檢視 > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: '檢視 > 旋轉檢視 > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: '檢視 > 旋轉檢視 > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: '檢視 > 旋轉檢視 > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: '檢視 > 旋轉檢視 > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: '檢視 > 旋轉檢視 > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: '檢視 > 旋轉檢視 > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: '檢視 > 旋轉檢視 > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: '檢視 > 旋轉檢視 > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: '檢視 > 旋轉檢視 > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: '檢視 > 旋轉檢視 > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: '檢視 > 旋轉檢視 > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: '檢視 > 旋轉檢視 > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: '檢視 > 重設旋轉檢視',
        placement: 'MenuBar',
        name: '重設旋轉檢視',
    },
    {
        id: 437,
        label: '編輯 > 貼上但不套用格式設定',
        placement: 'MenuBar',
        name: '貼上但不套用格式設定',
    },
    {
        id: 438,
        label: '說明 > 新增功能...',
        placement: 'MenuBar',
        name: '新增功能...',
    },
    {
        id: 440,
        label: '文字 > 項目符號和編號 > 套用項目符號',
        placement: 'MenuBar',
        name: '套用項目符號',
    },
    {
        id: 441,
        label: '文字 > 項目符號和編號 > 套用號碼',
        placement: 'MenuBar',
        name: '套用號碼',
    },
    {
        id: 448,
        label: '文字 > 項目符號和編號 > 轉換為文字',
        placement: 'MenuBar',
        name: '轉換為文字',
    },
    {
        id: 456,
        label: '文字 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: '物件 > 全部解散群組',
        placement: 'MenuBar',
        name: '全部解散群組',
    },
    {
        id: 472,
        label: '文字 > 插入空白字元 > 不斷行空格',
        placement: 'MenuBar',
        name: '不斷行空格',
    },
    {
        id: 1383427079,
        label: '檢視 > 尺標 > 變更為工作區域尺標',
        placement: 'MenuBar',
        name: '變更為工作區域尺標',
    },
    {
        id: 1633841013,
        label: 'Illustrator > 關於 Illustrator...',
        placement: 'MenuBar',
        name: '關於 Illustrator...',
    },
    {
        id: 1634233456,
        label: '說明 > Illustrator 說明...',
        placement: 'MenuBar',
        name: 'Illustrator 說明...',
    },
    {
        id: 1634296684,
        label: '檔案 > 關閉檔案',
        placement: 'MenuBar',
        name: '關閉檔案',
    },
    {
        id: 1668048225,
        label: '編輯 > 清除',
        placement: 'MenuBar',
        name: '清除',
    },
    {
        id: 1668247673,
        label: '編輯 > 拷貝',
        placement: 'MenuBar',
        name: '拷貝',
    },
    {
        id: 1668641824,
        label: '編輯 > 剪下',
        placement: 'MenuBar',
        name: '剪下',
    },
    {
        id: 1751737445,
        label: 'Illustrator > 隱藏 Illustrator',
        placement: 'MenuBar',
        name: '隱藏 Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > 隱藏其他',
        placement: 'MenuBar',
        name: '隱藏其他',
    },
    {
        id: 1852143392,
        label: '檔案 > 新增...',
        placement: 'MenuBar',
        name: '新增...',
    },
    {
        id: 1869636974,
        label: '檔案 > 開啟舊檔...',
        placement: 'MenuBar',
        name: '開啟舊檔...',
    },
    {
        id: 1885434740,
        label: '編輯 > 貼上',
        placement: 'MenuBar',
        name: '貼上',
    },
    {
        id: 1886545254,
        label: 'Illustrator > 偏好設定 > 一般...',
        placement: 'MenuBar',
        name: '一般...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > 結束 Illustrator',
        placement: 'MenuBar',
        name: '結束 Illustrator',
    },
    {
        id: 1919247471,
        label: '編輯 > 重做',
        placement: 'MenuBar',
        name: '重做',
    },
    {
        id: 1920365172,
        label: '檔案 > 回復',
        placement: 'MenuBar',
        name: '回復',
    },
    {
        id: 1934727834,
        label: '選取 > 作用中工作區域的全部',
        placement: 'MenuBar',
        name: '作用中工作區域的全部',
    },
    {
        id: 1935764588,
        label: '選取 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 1935767141,
        label: '檔案 > 儲存',
        placement: 'MenuBar',
        name: '儲存',
    },
    {
        id: 1936220524,
        label: 'Illustrator > 顯示全部',
        placement: 'MenuBar',
        name: '顯示全部',
    },
    {
        id: 1936292352,
        label: '文字 > 字級 > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: '文字 > 字級 > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: '文字 > 字級 > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: '文字 > 字級 > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: '文字 > 字級 > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: '文字 > 字級 > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: '文字 > 字級 > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: '文字 > 字級 > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: '文字 > 字級 > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: '文字 > 字級 > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: '文字 > 字級 > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: '文字 > 字級 > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: '文字 > 字級 > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: '文字 > 字級 > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: '文字 > 字級 > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: '文字 > 字級 > 其它...',
        placement: 'MenuBar',
        name: '其它...',
    },
    {
        id: 1937138035,
        label: '檔案 > 另存新檔...',
        placement: 'MenuBar',
        name: '另存新檔...',
    },
    {
        id: 1970168943,
        label: '編輯 > 還原',
        placement: 'MenuBar',
        name: '還原',
    },
    {
        id: 2164260867,
        label: '說明 > 管理我的帳戶...',
        placement: 'MenuBar',
        name: '管理我的帳戶...',
    },
    {
        id: 2164260869,
        label: '說明 > 更新...',
        placement: 'MenuBar',
        name: '更新...',
    },
    {
        id: 2164260870,
        label: '效果 > 應用上一個效果',
        placement: 'MenuBar',
        name: '應用上一個效果',
    },
    {
        id: 2164260871,
        label: '效果 > 上一個效果',
        placement: 'MenuBar',
        name: '上一個效果',
    },
    {
        id: 2164260872,
        label: '檔案 > 搜尋 Adobe Stock...',
        placement: 'MenuBar',
        name: '搜尋 Adobe Stock...',
    },
    {
        id: 2164260873,
        label: '檔案 > 置入...',
        placement: 'MenuBar',
        name: '置入...',
    },
    {
        id: 2164260874,
        label: '物件 > 路徑 > 移除錨點',
        placement: 'MenuBar',
        name: '移除錨點',
    },
    {
        id: 2164260877,
        label: '文字 > 複合字體...',
        placement: 'MenuBar',
        name: '複合字體...',
    },
    {
        id: 2164260879,
        label: '說明 > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260880,
        label: '說明 > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260882,
        label: '說明 > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260883,
        label: '說明 > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260884,
        label: '說明 > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260885,
        label: '說明 > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260886,
        label: '說明 > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260887,
        label: '說明 > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260889,
        label: '說明 > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260890,
        label: '說明 > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260892,
        label: '說明 > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260893,
        label: '說明 > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260894,
        label: '說明 > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260896,
        label: '說明 > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260897,
        label: '說明 > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260898,
        label: '說明 > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260899,
        label: '說明 > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260900,
        label: '說明 > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260901,
        label: '說明 > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260902,
        label: '說明 > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260903,
        label: '說明 > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260904,
        label: '說明 > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260905,
        label: '說明 > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260906,
        label: '說明 > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260908,
        label: '說明 > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260909,
        label: '說明 > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260910,
        label: '說明 > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260912,
        label: '視窗 > 資訊',
        placement: 'MenuBar',
        name: '資訊',
    },
    {
        id: 2164260914,
        label: '視窗 > 文字 > 字元',
        placement: 'MenuBar',
        name: '字元',
    },
    {
        id: 2164260915,
        label: '視窗 > 文字 > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 2164260916,
        label: '視窗 > 文字 > 定位點',
        placement: 'MenuBar',
        name: '定位點',
    },
    {
        id: 2164260917,
        label: '視窗 > 文字 > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260918,
        label: '文字 > 文字間距設定...',
        placement: 'MenuBar',
        name: '文字間距設定...',
    },
    {
        id: 2164260919,
        label: '效果 > Photoshop 效果',
        placement: 'MenuBar',
        name: 'Photoshop 效果',
    },
    {
        id: 2164260922,
        label: '效果 > 模糊 > 智慧型模糊...',
        placement: 'MenuBar',
        name: '智慧型模糊...',
    },
    {
        id: 2164260923,
        label: '效果 > 模糊 > 放射狀模糊...',
        placement: 'MenuBar',
        name: '放射狀模糊...',
    },
    {
        id: 2164260925,
        label: '效果 > 像素 > 點狀化...',
        placement: 'MenuBar',
        name: '點狀化...',
    },
    {
        id: 2164260926,
        label: '效果 > 像素 > 網線銅版...',
        placement: 'MenuBar',
        name: '網線銅版...',
    },
    {
        id: 2164260928,
        label: '效果 > 視訊效果 > 反交錯...',
        placement: 'MenuBar',
        name: '反交錯...',
    },
    {
        id: 2164260929,
        label: '效果 > 像素 > 結晶化...',
        placement: 'MenuBar',
        name: '結晶化...',
    },
    {
        id: 2164260930,
        label: '效果 > 像素 > 彩色網屏...',
        placement: 'MenuBar',
        name: '彩色網屏...',
    },
    {
        id: 2164260931,
        label: '效果 > 視訊效果 > NTSC 色彩',
        placement: 'MenuBar',
        name: 'NTSC 色彩',
    },
    {
        id: 2164260933,
        label: '效果 > 藝術風 > 水彩...',
        placement: 'MenuBar',
        name: '水彩...',
    },
    {
        id: 2164260935,
        label: '效果 > 素描 > 濕紙效果...',
        placement: 'MenuBar',
        name: '濕紙效果...',
    },
    {
        id: 2164260936,
        label: '效果 > 藝術風 > 著底色...',
        placement: 'MenuBar',
        name: '著底色...',
    },
    {
        id: 2164260937,
        label: '效果 > 素描 > 邊緣撕裂...',
        placement: 'MenuBar',
        name: '邊緣撕裂...',
    },
    {
        id: 2164260939,
        label: '效果 > 紋理 > 紋理化...',
        placement: 'MenuBar',
        name: '紋理化...',
    },
    {
        id: 2164260941,
        label: '效果 > 筆觸 > 墨繪...',
        placement: 'MenuBar',
        name: '墨繪...',
    },
    {
        id: 2164260942,
        label: '效果 > 素描 > 印章效果...',
        placement: 'MenuBar',
        name: '印章效果...',
    },
    {
        id: 2164260943,
        label: '效果 > 紋理 > 彩繪玻璃...',
        placement: 'MenuBar',
        name: '彩繪玻璃...',
    },
    {
        id: 2164260944,
        label: '效果 > 筆觸 > 噴灑...',
        placement: 'MenuBar',
        name: '噴灑...',
    },
    {
        id: 2164260945,
        label: '效果 > 藝術風 > 海綿效果...',
        placement: 'MenuBar',
        name: '海綿效果...',
    },
    {
        id: 2164260946,
        label: '效果 > 筆觸 > 潑濺...',
        placement: 'MenuBar',
        name: '潑濺...',
    },
    {
        id: 2164260947,
        label: '效果 > 藝術風 > 塗抹沾污...',
        placement: 'MenuBar',
        name: '塗抹沾污...',
    },
    {
        id: 2164260948,
        label: '效果 > 藝術風 > 粗粉蠟筆...',
        placement: 'MenuBar',
        name: '粗粉蠟筆...',
    },
    {
        id: 2164260949,
        label: '效果 > 素描 > 網狀效果...',
        placement: 'MenuBar',
        name: '網狀效果...',
    },
    {
        id: 2164260950,
        label: '效果 > 藝術風 > 海報邊緣...',
        placement: 'MenuBar',
        name: '海報邊緣...',
    },
    {
        id: 2164260951,
        label: '效果 > 藝術風 > 塑膠覆膜...',
        placement: 'MenuBar',
        name: '塑膠覆膜...',
    },
    {
        id: 2164260952,
        label: '效果 > 素描 > 石膏效果...',
        placement: 'MenuBar',
        name: '石膏效果...',
    },
    {
        id: 2164260953,
        label: '效果 > 素描 > 拓印...',
        placement: 'MenuBar',
        name: '拓印...',
    },
    {
        id: 2164260954,
        label: '效果 > 紋理 > 拼貼...',
        placement: 'MenuBar',
        name: '拼貼...',
    },
    {
        id: 2164260955,
        label: '效果 > 藝術風 > 調色刀...',
        placement: 'MenuBar',
        name: '調色刀...',
    },
    {
        id: 2164260956,
        label: '效果 > 藝術風 > 塗抹繪畫...',
        placement: 'MenuBar',
        name: '塗抹繪畫...',
    },
    {
        id: 2164260958,
        label: '效果 > 扭曲 > 海浪效果...',
        placement: 'MenuBar',
        name: '海浪效果...',
    },
    {
        id: 2164260959,
        label: '效果 > 素描 > 便條紙張效果...',
        placement: 'MenuBar',
        name: '便條紙張效果...',
    },
    {
        id: 2164260960,
        label: '效果 > 藝術風 > 霓虹光...',
        placement: 'MenuBar',
        name: '霓虹光...',
    },
    {
        id: 2164260961,
        label: '效果 > 紋理 > 嵌磚效果...',
        placement: 'MenuBar',
        name: '嵌磚效果...',
    },
    {
        id: 2164260962,
        label: '效果 > 筆觸 > 油墨外框...',
        placement: 'MenuBar',
        name: '油墨外框...',
    },
    {
        id: 2164260963,
        label: '效果 > 素描 > 網屏圖樣...',
        placement: 'MenuBar',
        name: '網屏圖樣...',
    },
    {
        id: 2164260964,
        label: '效果 > 素描 > 畫筆效果...',
        placement: 'MenuBar',
        name: '畫筆效果...',
    },
    {
        id: 2164260965,
        label: '效果 > 紋理 > 粒狀紋理...',
        placement: 'MenuBar',
        name: '粒狀紋理...',
    },
    {
        id: 2164260967,
        label: '效果 > 風格化 > 邊緣亮光化...',
        placement: 'MenuBar',
        name: '邊緣亮光化...',
    },
    {
        id: 2164260968,
        label: '效果 > 扭曲 > 玻璃效果...',
        placement: 'MenuBar',
        name: '玻璃效果...',
    },
    {
        id: 2164260969,
        label: '效果 > 藝術風 > 壁畫...',
        placement: 'MenuBar',
        name: '壁畫...',
    },
    {
        id: 2164260970,
        label: '效果 > 藝術風 > 粒狀影像...',
        placement: 'MenuBar',
        name: '粒狀影像...',
    },
    {
        id: 2164260971,
        label: '效果 > 藝術風 > 乾性筆刷...',
        placement: 'MenuBar',
        name: '乾性筆刷...',
    },
    {
        id: 2164260972,
        label: '效果 > 扭曲 > 擴散光暈...',
        placement: 'MenuBar',
        name: '擴散光暈...',
    },
    {
        id: 2164260973,
        label: '效果 > 筆觸 > 變暗筆觸...',
        placement: 'MenuBar',
        name: '變暗筆觸...',
    },
    {
        id: 2164260974,
        label: '效果 > 藝術風 > 挖剪圖案...',
        placement: 'MenuBar',
        name: '挖剪圖案...',
    },
    {
        id: 2164260975,
        label: '效果 > 筆觸 > 交叉底紋...',
        placement: 'MenuBar',
        name: '交叉底紋...',
    },
    {
        id: 2164260976,
        label: '效果 > 紋理 > 裂縫紋理...',
        placement: 'MenuBar',
        name: '裂縫紋理...',
    },
    {
        id: 2164260977,
        label: '效果 > 素描 > 蠟筆紋理...',
        placement: 'MenuBar',
        name: '蠟筆紋理...',
    },
    {
        id: 2164260978,
        label: '效果 > 藝術風 > 彩色鉛筆...',
        placement: 'MenuBar',
        name: '彩色鉛筆...',
    },
    {
        id: 2164260979,
        label: '效果 > 素描 > 鉻黃...',
        placement: 'MenuBar',
        name: '鉻黃...',
    },
    {
        id: 2164260980,
        label: '效果 > 素描 > 炭筆效果...',
        placement: 'MenuBar',
        name: '炭筆效果...',
    },
    {
        id: 2164260981,
        label: '效果 > 素描 > 粉筆和炭筆...',
        placement: 'MenuBar',
        name: '粉筆和炭筆...',
    },
    {
        id: 2164260982,
        label: '效果 > 素描 > 立體浮雕...',
        placement: 'MenuBar',
        name: '立體浮雕...',
    },
    {
        id: 2164260983,
        label: '效果 > 筆觸 > 角度筆觸...',
        placement: 'MenuBar',
        name: '角度筆觸...',
    },
    {
        id: 2164260984,
        label: '效果 > 筆觸 > 強調邊緣...',
        placement: 'MenuBar',
        name: '強調邊緣...',
    },
    {
        id: 2164260985,
        label: '效果 > 效果收藏館...',
        placement: 'MenuBar',
        name: '效果收藏館...',
    },
    {
        id: 2164260986,
        label: '編輯 > 編輯自訂字典...',
        placement: 'MenuBar',
        name: '編輯自訂字典...',
    },
    {
        id: 2164260989,
        label: '物件 > 路徑 > 分割成網格...',
        placement: 'MenuBar',
        name: '分割成網格...',
    },
    {
        id: 2164260991,
        label: '文字 > 變更大小寫 > 全部大寫',
        placement: 'MenuBar',
        name: '全部大寫',
    },
    {
        id: 2164260992,
        label: '文字 > 變更大小寫 > 全部小寫',
        placement: 'MenuBar',
        name: '全部小寫',
    },
    {
        id: 2164260993,
        label: '文字 > 變更大小寫 > 字首大寫',
        placement: 'MenuBar',
        name: '字首大寫',
    },
    {
        id: 2164260994,
        label: '文字 > 變更大小寫 > 句首大寫',
        placement: 'MenuBar',
        name: '句首大寫',
    },
    {
        id: 2164260995,
        label: '文字 > 視覺邊界對齊方式',
        placement: 'MenuBar',
        name: '視覺邊界對齊方式',
    },
    {
        id: 2164260996,
        label: '文字 > 尋找/取代字體...',
        placement: 'MenuBar',
        name: '尋找/取代字體...',
    },
    {
        id: 2164260997,
        label: '文字 > 智慧型標點...',
        placement: 'MenuBar',
        name: '智慧型標點...',
    },
    {
        id: 2164260998,
        label: '效果 > Illustrator 效果',
        placement: 'MenuBar',
        name: 'Illustrator 效果',
    },
    {
        id: 2164261001,
        label: '效果 > 扭曲與變形 > 變形...',
        placement: 'MenuBar',
        name: '變形...',
    },
    {
        id: 2164261002,
        label: '物件 > 變形 > 個別變形...',
        placement: 'MenuBar',
        name: '個別變形...',
    },
    {
        id: 2164261004,
        label: '視窗 > 資料庫',
        placement: 'MenuBar',
        name: '資料庫',
    },
    {
        id: 2164261006,
        label: '視窗 > 在 Exchange 上尋找延伸功能...',
        placement: 'MenuBar',
        name: '在 Exchange 上尋找延伸功能...',
    },
    {
        id: 2164261007,
        label: '物件 > 建立漸層網格...',
        placement: 'MenuBar',
        name: '建立漸層網格...',
    },
    {
        id: 2164261008,
        label: '視窗 > 分色預視',
        placement: 'MenuBar',
        name: '分色預視',
    },
    {
        id: 2164261009,
        label: '視窗 > 連結',
        placement: 'MenuBar',
        name: '連結',
    },
    {
        id: 2164261011,
        label: '編輯 > 編輯原稿',
        placement: 'MenuBar',
        name: '編輯原稿',
    },
    {
        id: 2164261013,
        label: '視窗 > 文字 > 段落樣式',
        placement: 'MenuBar',
        name: '段落樣式',
    },
    {
        id: 2164261014,
        label: '視窗 > 文字 > 字元樣式',
        placement: 'MenuBar',
        name: '字元樣式',
    },
    {
        id: 2164261015,
        label: '視窗 > 工作區域',
        placement: 'MenuBar',
        name: '工作區域',
    },
    {
        id: 2164261017,
        label: '物件 > 工作區域 > 重新排列所有工作區域順序',
        placement: 'MenuBar',
        name: '重新排列所有工作區域順序',
    },
    {
        id: 2164261019,
        label: '物件 > 工作區域 > 符合圖稿邊界',
        placement: 'MenuBar',
        name: '符合圖稿邊界',
    },
    {
        id: 2164261020,
        label: '物件 > 工作區域 > 符合選取的線條圖',
        placement: 'MenuBar',
        name: '符合選取的線條圖',
    },
    {
        id: 2164261021,
        label: '視窗 > 屬性',
        placement: 'MenuBar',
        name: '屬性',
    },
    {
        id: 2164261022,
        label: '視窗 > 導覽器',
        placement: 'MenuBar',
        name: '導覽器',
    },
    {
        id: 2164261025,
        label: '視窗 > 工作區 > 重設Getting Started',
        placement: 'MenuBar',
        name: '重設Getting Started',
    },
    {
        id: 2164261026,
        label: '視窗 > 工作區 > 新增工作區域...',
        placement: 'MenuBar',
        name: '新增工作區域...',
    },
    {
        id: 2164261027,
        label: '視窗 > 工作區 > 管理工作區域...',
        placement: 'MenuBar',
        name: '管理工作區域...',
    },
    {
        id: 2164261028,
        label: '視窗 > 工作區 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261029,
        label: '視窗 > 工作區 > 描圖',
        placement: 'MenuBar',
        name: '描圖',
    },
    {
        id: 2164261030,
        label: '視窗 > 工作區 > 基本功能',
        placement: 'MenuBar',
        name: '基本功能',
    },
    {
        id: 2164261031,
        label: '視窗 > 工作區 > 版面',
        placement: 'MenuBar',
        name: '版面',
    },
    {
        id: 2164261032,
        label: '視窗 > 工作區 > 自動',
        placement: 'MenuBar',
        name: '自動',
    },
    {
        id: 2164261033,
        label: '視窗 > 工作區 > 印刷樣式',
        placement: 'MenuBar',
        name: '印刷樣式',
    },
    {
        id: 2164261034,
        label: '視窗 > 工作區 > 列印和校樣',
        placement: 'MenuBar',
        name: '列印和校樣',
    },
    {
        id: 2164261035,
        label: '視窗 > 工作區 > 網頁',
        placement: 'MenuBar',
        name: '網頁',
    },
    {
        id: 2164261036,
        label: '視窗 > 工作區 > 傳統基本功能',
        placement: 'MenuBar',
        name: '傳統基本功能',
    },
    {
        id: 2164261037,
        label: '視窗 > 工作區 > 繪圖',
        placement: 'MenuBar',
        name: '繪圖',
    },
    {
        id: 2164261038,
        label: '文字 > 換行規則設定...',
        placement: 'MenuBar',
        name: '換行規則設定...',
    },
    {
        id: 2164261039,
        label: '編輯 > 鍵盤快捷鍵...',
        placement: 'MenuBar',
        name: '鍵盤快捷鍵...',
    },
    {
        id: 2164261040,
        label: '視窗 > 繪圖樣式',
        placement: 'MenuBar',
        name: '繪圖樣式',
    },
    {
        id: 2164261041,
        label: '視窗 > 外觀',
        placement: 'MenuBar',
        name: '外觀',
    },
    {
        id: 2164261047,
        label: '視窗 > 繪圖樣式資料庫 > 3D 效果',
        placement: 'MenuBar',
        name: '3D 效果',
    },
    {
        id: 2164261048,
        label: '視窗 > 繪圖樣式資料庫 > Vonster 圖樣樣式',
        placement: 'MenuBar',
        name: 'Vonster 圖樣樣式',
    },
    {
        id: 2164261049,
        label: '視窗 > 繪圖樣式資料庫 > 加法類',
        placement: 'MenuBar',
        name: '加法類',
    },
    {
        id: 2164261050,
        label: '視窗 > 繪圖樣式資料庫 > 加法類點滴筆刷',
        placement: 'MenuBar',
        name: '加法類點滴筆刷',
    },
    {
        id: 2164261051,
        label: '視窗 > 繪圖樣式資料庫 > 塗抹效果',
        placement: 'MenuBar',
        name: '塗抹效果',
    },
    {
        id: 2164261052,
        label: '視窗 > 繪圖樣式資料庫 > 影像效果',
        placement: 'MenuBar',
        name: '影像效果',
    },
    {
        id: 2164261053,
        label: '視窗 > 繪圖樣式資料庫 > 按鈕和滑鼠指向效果',
        placement: 'MenuBar',
        name: '按鈕和滑鼠指向效果',
    },
    {
        id: 2164261054,
        label: '視窗 > 繪圖樣式資料庫 > 文字效果',
        placement: 'MenuBar',
        name: '文字效果',
    },
    {
        id: 2164261055,
        label: '視窗 > 繪圖樣式資料庫 > 照亮樣式',
        placement: 'MenuBar',
        name: '照亮樣式',
    },
    {
        id: 2164261056,
        label: '視窗 > 繪圖樣式資料庫 > 紋理',
        placement: 'MenuBar',
        name: '紋理',
    },
    {
        id: 2164261057,
        label: '視窗 > 繪圖樣式資料庫 > 藝術效果',
        placement: 'MenuBar',
        name: '藝術效果',
    },
    {
        id: 2164261058,
        label: '視窗 > 繪圖樣式資料庫 > 霓虹效果',
        placement: 'MenuBar',
        name: '霓虹效果',
    },
    {
        id: 2164261061,
        label: '視窗 > 繪圖樣式資料庫 > 其它資料庫...',
        placement: 'MenuBar',
        name: '其它資料庫...',
    },
    {
        id: 2164261062,
        label: '視窗 > 符號',
        placement: 'MenuBar',
        name: '符號',
    },
    {
        id: 2164261064,
        label: '視窗 > 符號資料庫 > 3D 符號',
        placement: 'MenuBar',
        name: '3D 符號',
    },
    {
        id: 2164261065,
        label: '視窗 > 符號資料庫 > 傳家寶',
        placement: 'MenuBar',
        name: '傳家寶',
    },
    {
        id: 2164261066,
        label: '視窗 > 符號資料庫 > 原始風格',
        placement: 'MenuBar',
        name: '原始風格',
    },
    {
        id: 2164261067,
        label: '視窗 > 符號資料庫 > 圖表',
        placement: 'MenuBar',
        name: '圖表',
    },
    {
        id: 2164261068,
        label: '視窗 > 符號資料庫 > 地圖',
        placement: 'MenuBar',
        name: '地圖',
    },
    {
        id: 2164261069,
        label: '視窗 > 符號資料庫 > 壽司',
        placement: 'MenuBar',
        name: '壽司',
    },
    {
        id: 2164261070,
        label: '視窗 > 符號資料庫 > 帝王向量包',
        placement: 'MenuBar',
        name: '帝王向量包',
    },
    {
        id: 2164261071,
        label: '視窗 > 符號資料庫 > 慶祝',
        placement: 'MenuBar',
        name: '慶祝',
    },
    {
        id: 2164261072,
        label: '視窗 > 符號資料庫 > 懷舊藝術',
        placement: 'MenuBar',
        name: '懷舊藝術',
    },
    {
        id: 2164261073,
        label: '視窗 > 符號資料庫 > 手機',
        placement: 'MenuBar',
        name: '手機',
    },
    {
        id: 2164261074,
        label: '視窗 > 符號資料庫 > 標誌項目',
        placement: 'MenuBar',
        name: '標誌項目',
    },
    {
        id: 2164261075,
        label: '視窗 > 符號資料庫 > 毛利族',
        placement: 'MenuBar',
        name: '毛利族',
    },
    {
        id: 2164261076,
        label: '視窗 > 符號資料庫 > 毛髮與毛皮',
        placement: 'MenuBar',
        name: '毛髮與毛皮',
    },
    {
        id: 2164261077,
        label: '視窗 > 符號資料庫 > 汙點向量包',
        placement: 'MenuBar',
        name: '汙點向量包',
    },
    {
        id: 2164261078,
        label: '視窗 > 符號資料庫 > 流行',
        placement: 'MenuBar',
        name: '流行',
    },
    {
        id: 2164261079,
        label: '視窗 > 符號資料庫 > 照亮流程圖',
        placement: 'MenuBar',
        name: '照亮流程圖',
    },
    {
        id: 2164261080,
        label: '視窗 > 符號資料庫 > 照亮組織圖',
        placement: 'MenuBar',
        name: '照亮組織圖',
    },
    {
        id: 2164261081,
        label: '視窗 > 符號資料庫 > 照亮緞帶',
        placement: 'MenuBar',
        name: '照亮緞帶',
    },
    {
        id: 2164261082,
        label: '視窗 > 符號資料庫 > 科學狂熱',
        placement: 'MenuBar',
        name: '科學狂熱',
    },
    {
        id: 2164261083,
        label: '視窗 > 符號資料庫 > 箭頭',
        placement: 'MenuBar',
        name: '箭頭',
    },
    {
        id: 2164261084,
        label: '視窗 > 符號資料庫 > 網頁圖示',
        placement: 'MenuBar',
        name: '網頁圖示',
    },
    {
        id: 2164261085,
        label: '視窗 > 符號資料庫 > 網頁按鈕和橫條',
        placement: 'MenuBar',
        name: '網頁按鈕和橫條',
    },
    {
        id: 2164261086,
        label: '視窗 > 符號資料庫 > 自然',
        placement: 'MenuBar',
        name: '自然',
    },
    {
        id: 2164261087,
        label: '視窗 > 符號資料庫 > 花朵',
        placement: 'MenuBar',
        name: '花朵',
    },
    {
        id: 2164261088,
        label: '視窗 > 符號資料庫 > 華麗向量包',
        placement: 'MenuBar',
        name: '華麗向量包',
    },
    {
        id: 2164261089,
        label: '視窗 > 符號資料庫 > 藝術紋理',
        placement: 'MenuBar',
        name: '藝術紋理',
    },
    {
        id: 2164261090,
        label: '視窗 > 符號資料庫 > 通訊',
        placement: 'MenuBar',
        name: '通訊',
    },
    {
        id: 2164261091,
        label: '視窗 > 符號資料庫 > 點狀圖樣向量包',
        placement: 'MenuBar',
        name: '點狀圖樣向量包',
    },
    {
        id: 2164261094,
        label: '視窗 > 符號資料庫 > 其它資料庫...',
        placement: 'MenuBar',
        name: '其它資料庫...',
    },
    {
        id: 2164261096,
        label: '檢視 > 智慧型參考線',
        placement: 'MenuBar',
        name: '智慧型參考線',
    },
    {
        id: 2164261097,
        label: '視窗 > 平面化工具預視',
        placement: 'MenuBar',
        name: '平面化工具預視',
    },
    {
        id: 2164261098,
        label: '視窗 > 歷史記錄',
        placement: 'MenuBar',
        name: '歷史記錄',
    },
    {
        id: 2164261100,
        label: '文字 > 字符',
        placement: 'MenuBar',
        name: '字符',
    },
    {
        id: 2164261101,
        label: '視窗 > 文字 > 字符',
        placement: 'MenuBar',
        name: '字符',
    },
    {
        id: 2164261102,
        label: '視窗 > 動作',
        placement: 'MenuBar',
        name: '動作',
    },
    {
        id: 2164261104,
        label: '選取 > 反轉選取',
        placement: 'MenuBar',
        name: '反轉選取',
    },
    {
        id: 2164261106,
        label: '效果 > 風格化 > 製作陰影...',
        placement: 'MenuBar',
        name: '製作陰影...',
    },
    {
        id: 2164261107,
        label: '效果 > 風格化 > 外光暈...',
        placement: 'MenuBar',
        name: '外光暈...',
    },
    {
        id: 2164261108,
        label: '效果 > 風格化 > 內光暈...',
        placement: 'MenuBar',
        name: '內光暈...',
    },
    {
        id: 2164261110,
        label: '效果 > 轉換為以下形狀 > 矩形...',
        placement: 'MenuBar',
        name: '矩形...',
    },
    {
        id: 2164261111,
        label: '效果 > 轉換為以下形狀 > 圓角矩形...',
        placement: 'MenuBar',
        name: '圓角矩形...',
    },
    {
        id: 2164261112,
        label: '效果 > 轉換為以下形狀 > 橢圓...',
        placement: 'MenuBar',
        name: '橢圓...',
    },
    {
        id: 2164261113,
        label: '效果 > 風格化 > 圓角...',
        placement: 'MenuBar',
        name: '圓角...',
    },
    {
        id: 2164261115,
        label: '物件 > 路徑 > 清除...',
        placement: 'MenuBar',
        name: '清除...',
    },
    {
        id: 2164261117,
        label: '編輯 > 編輯色彩 > 黑色疊印...',
        placement: 'MenuBar',
        name: '黑色疊印...',
    },
    {
        id: 2164261118,
        label: '效果 > 扭曲與變形 > 隨意扭曲...',
        placement: 'MenuBar',
        name: '隨意扭曲...',
    },
    {
        id: 2164261119,
        label: '效果 > 扭曲與變形 > 縮攏與膨脹...',
        placement: 'MenuBar',
        name: '縮攏與膨脹...',
    },
    {
        id: 2164261121,
        label: '物件 > 繞圖排文 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261122,
        label: '物件 > 繞圖排文 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261124,
        label: '物件 > 繞圖排文 > 繞圖排文選項...',
        placement: 'MenuBar',
        name: '繞圖排文選項...',
    },
    {
        id: 2164261125,
        label: '效果 > 扭曲與變形 > 隨意筆畫...',
        placement: 'MenuBar',
        name: '隨意筆畫...',
    },
    {
        id: 2164261126,
        label: '選取 > 物件 > 剪裁遮色片',
        placement: 'MenuBar',
        name: '剪裁遮色片',
    },
    {
        id: 2164261127,
        label: '編輯 > 編輯色彩 > 由前至後漸變',
        placement: 'MenuBar',
        name: '由前至後漸變',
    },
    {
        id: 2164261128,
        label: '編輯 > 編輯色彩 > 水平漸變',
        placement: 'MenuBar',
        name: '水平漸變',
    },
    {
        id: 2164261129,
        label: '編輯 > 編輯色彩 > 垂直漸變',
        placement: 'MenuBar',
        name: '垂直漸變',
    },
    {
        id: 2164261130,
        label: '編輯 > 編輯色彩 > 反轉顏色',
        placement: 'MenuBar',
        name: '反轉顏色',
    },
    {
        id: 2164261131,
        label: '編輯 > 編輯色彩 > 轉換為灰階',
        placement: 'MenuBar',
        name: '轉換為灰階',
    },
    {
        id: 2164261132,
        label: '編輯 > 編輯色彩 > 轉換為 CMYK',
        placement: 'MenuBar',
        name: '轉換為 CMYK',
    },
    {
        id: 2164261133,
        label: '編輯 > 編輯色彩 > 轉換為 RGB',
        placement: 'MenuBar',
        name: '轉換為 RGB',
    },
    {
        id: 2164261134,
        label: '編輯 > 編輯色彩 > 飽和度...',
        placement: 'MenuBar',
        name: '飽和度...',
    },
    {
        id: 2164261136,
        label: '物件 > 路徑 > 增加錨點',
        placement: 'MenuBar',
        name: '增加錨點',
    },
    {
        id: 2164261137,
        label: '編輯 > 編輯色彩 > 調整色彩平衡...',
        placement: 'MenuBar',
        name: '調整色彩平衡...',
    },
    {
        id: 2164261138,
        label: '物件 > 建立物件馬賽克...',
        placement: 'MenuBar',
        name: '建立物件馬賽克...',
    },
    {
        id: 2164261139,
        label: '效果 > 扭曲與變形 > 粗糙效果...',
        placement: 'MenuBar',
        name: '粗糙效果...',
    },
    {
        id: 2164261140,
        label: '選取 > 重新選取',
        placement: 'MenuBar',
        name: '重新選取',
    },
    {
        id: 2164261142,
        label: '選取 > 相同 > 形狀和文字',
        placement: 'MenuBar',
        name: '形狀和文字',
    },
    {
        id: 2164261143,
        label: '選取 > 相同 > 文字',
        placement: 'MenuBar',
        name: '文字',
    },
    {
        id: 2164261145,
        label: '選取 > 相同 > 填色顏色',
        placement: 'MenuBar',
        name: '填色顏色',
    },
    {
        id: 2164261146,
        label: '選取 > 相同 > 繪圖樣式',
        placement: 'MenuBar',
        name: '繪圖樣式',
    },
    {
        id: 2164261147,
        label: '選取 > 相同 > 填色與筆畫',
        placement: 'MenuBar',
        name: '填色與筆畫',
    },
    {
        id: 2164261148,
        label: '選取 > 相同 > 筆畫顏色',
        placement: 'MenuBar',
        name: '筆畫顏色',
    },
    {
        id: 2164261149,
        label: '選取 > 相同 > 筆畫寬度',
        placement: 'MenuBar',
        name: '筆畫寬度',
    },
    {
        id: 2164261150,
        label: '選取 > 相同 > 漸變模式',
        placement: 'MenuBar',
        name: '漸變模式',
    },
    {
        id: 2164261151,
        label: '選取 > 相同 > 不透明度',
        placement: 'MenuBar',
        name: '不透明度',
    },
    {
        id: 2164261152,
        label: '選取 > 相同 > 形狀',
        placement: 'MenuBar',
        name: '形狀',
    },
    {
        id: 2164261153,
        label: '選取 > 相同 > 符號範例',
        placement: 'MenuBar',
        name: '符號範例',
    },
    {
        id: 2164261154,
        label: '選取 > 相同 > 連結區塊系列',
        placement: 'MenuBar',
        name: '連結區塊系列',
    },
    {
        id: 2164261155,
        label: '選取 > 相同 > 外觀',
        placement: 'MenuBar',
        name: '外觀',
    },
    {
        id: 2164261156,
        label: '選取 > 相同 > 外觀屬性',
        placement: 'MenuBar',
        name: '外觀屬性',
    },
    {
        id: 2164261157,
        label: '選取 > 相同 > 文字填色顏色',
        placement: 'MenuBar',
        name: '文字填色顏色',
    },
    {
        id: 2164261158,
        label: '選取 > 相同 > 文字筆畫顏色',
        placement: 'MenuBar',
        name: '文字筆畫顏色',
    },
    {
        id: 2164261159,
        label: '選取 > 相同 > 文字填色與筆畫顏色',
        placement: 'MenuBar',
        name: '文字填色與筆畫顏色',
    },
    {
        id: 2164261160,
        label: '選取 > 相同 > 字體大小',
        placement: 'MenuBar',
        name: '字體大小',
    },
    {
        id: 2164261161,
        label: '選取 > 相同 > 字體系列',
        placement: 'MenuBar',
        name: '字體系列',
    },
    {
        id: 2164261162,
        label: '選取 > 相同 > 字體系列和樣式',
        placement: 'MenuBar',
        name: '字體系列和樣式',
    },
    {
        id: 2164261163,
        label: '選取 > 相同 > 字體系列、樣式和大小',
        placement: 'MenuBar',
        name: '字體系列、樣式和大小',
    },
    {
        id: 2164261164,
        label: '選取 > 物件 > 孤立控制點',
        placement: 'MenuBar',
        name: '孤立控制點',
    },
    {
        id: 2164261166,
        label: '選取 > 物件 > 所有文字物件',
        placement: 'MenuBar',
        name: '所有文字物件',
    },
    {
        id: 2164261167,
        label: '選取 > 物件 > 點狀文字物件',
        placement: 'MenuBar',
        name: '點狀文字物件',
    },
    {
        id: 2164261168,
        label: '選取 > 物件 > 區域文字物件',
        placement: 'MenuBar',
        name: '區域文字物件',
    },
    {
        id: 2164261169,
        label: '效果 > 扭曲與變形 > 鋸齒化...',
        placement: 'MenuBar',
        name: '鋸齒化...',
    },
    {
        id: 2164261170,
        label: '效果 > 裁切標記',
        placement: 'MenuBar',
        name: '裁切標記',
    },
    {
        id: 2164261171,
        label: '物件 > 建立剪裁標記',
        placement: 'MenuBar',
        name: '建立剪裁標記',
    },
    {
        id: 2164261172,
        label: '檔案 > 封裝...',
        placement: 'MenuBar',
        name: '封裝...',
    },
    {
        id: 2164261173,
        label: '視窗 > 圖層',
        placement: 'MenuBar',
        name: '圖層',
    },
    {
        id: 2164261176,
        label: '檔案 > 在 Bridge 中瀏覽...',
        placement: 'MenuBar',
        name: '在 Bridge 中瀏覽...',
    },
    {
        id: 2164261177,
        label: '檔案 > 檔案資訊...',
        placement: 'MenuBar',
        name: '檔案資訊...',
    },
    {
        id: 2164261178,
        label: '視窗 > 文件資訊',
        placement: 'MenuBar',
        name: '文件資訊',
    },
    {
        id: 2164261180,
        label: '效果 > 路徑管理員 > 相加',
        placement: 'MenuBar',
        name: '相加',
    },
    {
        id: 2164261181,
        label: '效果 > 路徑管理員 > 交集',
        placement: 'MenuBar',
        name: '交集',
    },
    {
        id: 2164261182,
        label: '效果 > 路徑管理員 > 差集',
        placement: 'MenuBar',
        name: '差集',
    },
    {
        id: 2164261183,
        label: '效果 > 路徑管理員 > 相減',
        placement: 'MenuBar',
        name: '相減',
    },
    {
        id: 2164261184,
        label: '效果 > 路徑管理員 > 依後置物件剪裁',
        placement: 'MenuBar',
        name: '依後置物件剪裁',
    },
    {
        id: 2164261185,
        label: '效果 > 路徑管理員 > 分割',
        placement: 'MenuBar',
        name: '分割',
    },
    {
        id: 2164261186,
        label: '效果 > 路徑管理員 > 剪裁覆蓋範圍',
        placement: 'MenuBar',
        name: '剪裁覆蓋範圍',
    },
    {
        id: 2164261187,
        label: '效果 > 路徑管理員 > 合併',
        placement: 'MenuBar',
        name: '合併',
    },
    {
        id: 2164261188,
        label: '效果 > 路徑管理員 > 裁切',
        placement: 'MenuBar',
        name: '裁切',
    },
    {
        id: 2164261189,
        label: '效果 > 路徑管理員 > 外框',
        placement: 'MenuBar',
        name: '外框',
    },
    {
        id: 2164261190,
        label: '效果 > 路徑管理員 > 實色疊印混合',
        placement: 'MenuBar',
        name: '實色疊印混合',
    },
    {
        id: 2164261191,
        label: '效果 > 路徑管理員 > 透明疊印混合...',
        placement: 'MenuBar',
        name: '透明疊印混合...',
    },
    {
        id: 2164261192,
        label: '效果 > 路徑管理員 > 補漏白...',
        placement: 'MenuBar',
        name: '補漏白...',
    },
    {
        id: 2164261193,
        label: '檢視 > 顯示即時上色間隙',
        placement: 'MenuBar',
        name: '顯示即時上色間隙',
    },
    {
        id: 2164261196,
        label: '物件 > 即時上色 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261197,
        label: '物件 > 即時上色 > 合併',
        placement: 'MenuBar',
        name: '合併',
    },
    {
        id: 2164261198,
        label: '物件 > 即時上色 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261200,
        label: '物件 > 即時上色 > 間隙選項...',
        placement: 'MenuBar',
        name: '間隙選項...',
    },
    {
        id: 2164261202,
        label: '物件 > 即時上色 > 展開',
        placement: 'MenuBar',
        name: '展開',
    },
    {
        id: 2164261203,
        label: '效果 > 風格化 > 塗抹...',
        placement: 'MenuBar',
        name: '塗抹...',
    },
    {
        id: 2164261205,
        label: '物件 > 封套扭曲 > 以彎曲製作...',
        placement: 'MenuBar',
        name: '以彎曲製作...',
    },
    {
        id: 2164261206,
        label: '物件 > 封套扭曲 > 以網格製作...',
        placement: 'MenuBar',
        name: '以網格製作...',
    },
    {
        id: 2164261207,
        label: '物件 > 封套扭曲 > 以上層物件製作',
        placement: 'MenuBar',
        name: '以上層物件製作',
    },
    {
        id: 2164261208,
        label: '物件 > 封套扭曲 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261210,
        label: '物件 > 封套扭曲 > 封套選項...',
        placement: 'MenuBar',
        name: '封套選項...',
    },
    {
        id: 2164261212,
        label: '物件 > 封套扭曲 > 展開',
        placement: 'MenuBar',
        name: '展開',
    },
    {
        id: 2164261214,
        label: '物件 > 封套扭曲 > 編輯內容',
        placement: 'MenuBar',
        name: '編輯內容',
    },
    {
        id: 2164261216,
        label: '效果 > 彎曲 > 弧形...',
        placement: 'MenuBar',
        name: '弧形...',
    },
    {
        id: 2164261217,
        label: '效果 > 彎曲 > 下弧形...',
        placement: 'MenuBar',
        name: '下弧形...',
    },
    {
        id: 2164261218,
        label: '效果 > 彎曲 > 上弧形...',
        placement: 'MenuBar',
        name: '上弧形...',
    },
    {
        id: 2164261219,
        label: '效果 > 彎曲 > 拱形...',
        placement: 'MenuBar',
        name: '拱形...',
    },
    {
        id: 2164261220,
        label: '效果 > 彎曲 > 凸形...',
        placement: 'MenuBar',
        name: '凸形...',
    },
    {
        id: 2164261221,
        label: '效果 > 彎曲 > 凹殼...',
        placement: 'MenuBar',
        name: '凹殼...',
    },
    {
        id: 2164261222,
        label: '效果 > 彎曲 > 凸殼...',
        placement: 'MenuBar',
        name: '凸殼...',
    },
    {
        id: 2164261223,
        label: '效果 > 彎曲 > 旗形...',
        placement: 'MenuBar',
        name: '旗形...',
    },
    {
        id: 2164261224,
        label: '效果 > 彎曲 > 波形...',
        placement: 'MenuBar',
        name: '波形...',
    },
    {
        id: 2164261225,
        label: '效果 > 彎曲 > 魚形...',
        placement: 'MenuBar',
        name: '魚形...',
    },
    {
        id: 2164261226,
        label: '效果 > 彎曲 > 上升...',
        placement: 'MenuBar',
        name: '上升...',
    },
    {
        id: 2164261227,
        label: '效果 > 彎曲 > 魚眼...',
        placement: 'MenuBar',
        name: '魚眼...',
    },
    {
        id: 2164261228,
        label: '效果 > 彎曲 > 膨脹...',
        placement: 'MenuBar',
        name: '膨脹...',
    },
    {
        id: 2164261229,
        label: '效果 > 彎曲 > 擠壓...',
        placement: 'MenuBar',
        name: '擠壓...',
    },
    {
        id: 2164261230,
        label: '效果 > 彎曲 > 螺旋...',
        placement: 'MenuBar',
        name: '螺旋...',
    },
    {
        id: 2164261231,
        label: '物件 > 展開...',
        placement: 'MenuBar',
        name: '展開...',
    },
    {
        id: 2164261233,
        label: '編輯 > 拼字檢查 > 自動拼字檢查',
        placement: 'MenuBar',
        name: '自動拼字檢查',
    },
    {
        id: 2164261234,
        label: '編輯 > 拼字檢查 > 拼字檢查...',
        placement: 'MenuBar',
        name: '拼字檢查...',
    },
    {
        id: 2164261235,
        label: '選取 > 開始整體編輯',
        placement: 'MenuBar',
        name: '開始整體編輯',
    },
    {
        id: 2164261236,
        label: 'Illustrator > 偏好設定 > 效能...',
        placement: 'MenuBar',
        name: '效能...',
    },
    {
        id: 2164261237,
        label: 'Illustrator > 偏好設定 > 檔案處理...',
        placement: 'MenuBar',
        name: '檔案處理...',
    },
    {
        id: 2164261238,
        label: 'Illustrator > 偏好設定 > 剪貼簿處理...',
        placement: 'MenuBar',
        name: '剪貼簿處理...',
    },
    {
        id: 2164261239,
        label: 'Illustrator > 偏好設定 > 黑色外觀...',
        placement: 'MenuBar',
        name: '黑色外觀...',
    },
    {
        id: 2164261240,
        label: 'Illustrator > 偏好設定 > 裝置...',
        placement: 'MenuBar',
        name: '裝置...',
    },
    {
        id: 2164261241,
        label: '視窗 > 筆刷',
        placement: 'MenuBar',
        name: '筆刷',
    },
    {
        id: 2164261242,
        label: '選取 > 物件 > 筆刷筆畫',
        placement: 'MenuBar',
        name: '筆刷筆畫',
    },
    {
        id: 2164261245,
        label: '視窗 > 筆刷資料庫 > Wacom 6D 筆刷 > 6d 藝術鋼筆筆刷',
        placement: 'MenuBar',
        name: '6d 藝術鋼筆筆刷',
    },
    {
        id: 2164261247,
        label: '視窗 > 筆刷資料庫 > 向量包 > 手繪筆刷向量包',
        placement: 'MenuBar',
        name: '手繪筆刷向量包',
    },
    {
        id: 2164261248,
        label: '視窗 > 筆刷資料庫 > 向量包 > 頹廢筆刷向量包',
        placement: 'MenuBar',
        name: '頹廢筆刷向量包',
    },
    {
        id: 2164261250,
        label: '視窗 > 筆刷資料庫 > 影像筆刷 > 影像筆刷資料庫',
        placement: 'MenuBar',
        name: '影像筆刷資料庫',
    },
    {
        id: 2164261252,
        label: '視窗 > 筆刷資料庫 > 毛刷筆刷 > 毛刷筆刷資料庫',
        placement: 'MenuBar',
        name: '毛刷筆刷資料庫',
    },
    {
        id: 2164261254,
        label: '視窗 > 筆刷資料庫 > 箭頭 > 圖樣箭頭',
        placement: 'MenuBar',
        name: '圖樣箭頭',
    },
    {
        id: 2164261255,
        label: '視窗 > 筆刷資料庫 > 箭頭 > 箭頭_標準箭頭',
        placement: 'MenuBar',
        name: '箭頭_標準箭頭',
    },
    {
        id: 2164261256,
        label: '視窗 > 筆刷資料庫 > 箭頭 > 箭頭_特殊箭頭',
        placement: 'MenuBar',
        name: '箭頭_特殊箭頭',
    },
    {
        id: 2164261258,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_墨水',
        placement: 'MenuBar',
        name: '藝術_墨水',
    },
    {
        id: 2164261259,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_捲軸筆',
        placement: 'MenuBar',
        name: '藝術_捲軸筆',
    },
    {
        id: 2164261260,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_書法',
        placement: 'MenuBar',
        name: '藝術_書法',
    },
    {
        id: 2164261261,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_水彩',
        placement: 'MenuBar',
        name: '藝術_水彩',
    },
    {
        id: 2164261262,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_畫筆',
        placement: 'MenuBar',
        name: '藝術_畫筆',
    },
    {
        id: 2164261263,
        label: '視窗 > 筆刷資料庫 > 藝術 > 藝術_粉筆炭筆鉛筆',
        placement: 'MenuBar',
        name: '藝術_粉筆炭筆鉛筆',
    },
    {
        id: 2164261265,
        label: '視窗 > 筆刷資料庫 > 裝飾 > 典雅的捲曲和花卉筆刷組合',
        placement: 'MenuBar',
        name: '典雅的捲曲和花卉筆刷組合',
    },
    {
        id: 2164261266,
        label: '視窗 > 筆刷資料庫 > 裝飾 > 裝飾_散佈',
        placement: 'MenuBar',
        name: '裝飾_散佈',
    },
    {
        id: 2164261267,
        label: '視窗 > 筆刷資料庫 > 裝飾 > 裝飾_文字分隔線',
        placement: 'MenuBar',
        name: '裝飾_文字分隔線',
    },
    {
        id: 2164261268,
        label: '視窗 > 筆刷資料庫 > 裝飾 > 裝飾_橫幅與封條',
        placement: 'MenuBar',
        name: '裝飾_橫幅與封條',
    },
    {
        id: 2164261270,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_原始',
        placement: 'MenuBar',
        name: '邊框_原始',
    },
    {
        id: 2164261271,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_幾何圖形',
        placement: 'MenuBar',
        name: '邊框_幾何圖形',
    },
    {
        id: 2164261272,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_新奇',
        placement: 'MenuBar',
        name: '邊框_新奇',
    },
    {
        id: 2164261273,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_框架',
        placement: 'MenuBar',
        name: '邊框_框架',
    },
    {
        id: 2164261274,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_直線',
        placement: 'MenuBar',
        name: '邊框_直線',
    },
    {
        id: 2164261275,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_虛線',
        placement: 'MenuBar',
        name: '邊框_虛線',
    },
    {
        id: 2164261276,
        label: '視窗 > 筆刷資料庫 > 邊框 > 邊框_裝飾',
        placement: 'MenuBar',
        name: '邊框_裝飾',
    },
    {
        id: 2164261279,
        label: '視窗 > 筆刷資料庫 > 其它資料庫...',
        placement: 'MenuBar',
        name: '其它資料庫...',
    },
    {
        id: 2164261280,
        label: '視窗 > 路徑管理員',
        placement: 'MenuBar',
        name: '路徑管理員',
    },
    {
        id: 2164261281,
        label: '編輯 > 尋找及取代...',
        placement: 'MenuBar',
        name: '尋找及取代...',
    },
    {
        id: 2164261282,
        label: '編輯 > 找下一個',
        placement: 'MenuBar',
        name: '找下一個',
    },
    {
        id: 2164261283,
        label: '效果 > 點陣化...',
        placement: 'MenuBar',
        name: '點陣化...',
    },
    {
        id: 2164261285,
        label: '效果 > 文件點陣效果設定...',
        placement: 'MenuBar',
        name: '文件點陣效果設定...',
    },
    {
        id: 2164261286,
        label: '物件 > 點陣化...',
        placement: 'MenuBar',
        name: '點陣化...',
    },
    {
        id: 2164261288,
        label: '物件 > 漸變 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261289,
        label: '物件 > 漸變 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261291,
        label: '物件 > 漸變 > 漸變選項...',
        placement: 'MenuBar',
        name: '漸變選項...',
    },
    {
        id: 2164261293,
        label: '物件 > 漸變 > 展開',
        placement: 'MenuBar',
        name: '展開',
    },
    {
        id: 2164261295,
        label: '物件 > 漸變 > 取代旋轉',
        placement: 'MenuBar',
        name: '取代旋轉',
    },
    {
        id: 2164261296,
        label: '物件 > 漸變 > 反轉旋轉',
        placement: 'MenuBar',
        name: '反轉旋轉',
    },
    {
        id: 2164261297,
        label: '物件 > 漸變 > 由前至後反轉',
        placement: 'MenuBar',
        name: '由前至後反轉',
    },
    {
        id: 2164261299,
        label: '檢視 > 顯示切片',
        placement: 'MenuBar',
        name: '顯示切片',
    },
    {
        id: 2164261300,
        label: '檢視 > 鎖定切片',
        placement: 'MenuBar',
        name: '鎖定切片',
    },
    {
        id: 2164261303,
        label: '物件 > 切片 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261304,
        label: '物件 > 切片 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261306,
        label: '物件 > 切片 > 從參考線建立',
        placement: 'MenuBar',
        name: '從參考線建立',
    },
    {
        id: 2164261307,
        label: '物件 > 切片 > 從選取範圍建立',
        placement: 'MenuBar',
        name: '從選取範圍建立',
    },
    {
        id: 2164261309,
        label: '物件 > 切片 > 複製切片',
        placement: 'MenuBar',
        name: '複製切片',
    },
    {
        id: 2164261310,
        label: '物件 > 切片 > 結合切片',
        placement: 'MenuBar',
        name: '結合切片',
    },
    {
        id: 2164261311,
        label: '物件 > 切片 > 分割切片...',
        placement: 'MenuBar',
        name: '分割切片...',
    },
    {
        id: 2164261312,
        label: '物件 > 切片 > 刪除全部',
        placement: 'MenuBar',
        name: '刪除全部',
    },
    {
        id: 2164261314,
        label: '物件 > 切片 > 切片選項...',
        placement: 'MenuBar',
        name: '切片選項...',
    },
    {
        id: 2164261316,
        label: '物件 > 切片 > 剪裁至工作區域',
        placement: 'MenuBar',
        name: '剪裁至工作區域',
    },
    {
        id: 2164261317,
        label: '視窗 > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261318,
        label: '檔案 > 儲存選取的切片...',
        placement: 'MenuBar',
        name: '儲存選取的切片...',
    },
    {
        id: 2164261320,
        label: '效果 > SVG 濾鏡 > 套用 SVG 濾鏡...',
        placement: 'MenuBar',
        name: '套用 SVG 濾鏡...',
    },
    {
        id: 2164261321,
        label: '效果 > SVG 濾鏡 > 讀入 SVG 濾鏡...',
        placement: 'MenuBar',
        name: '讀入 SVG 濾鏡...',
    },
    {
        id: 2164261323,
        label: '效果 > 風格化 > 羽化...',
        placement: 'MenuBar',
        name: '羽化...',
    },
    {
        id: 2164261325,
        label: '效果 > 3D 和素材 > 突出與斜角...',
        placement: 'MenuBar',
        name: '突出與斜角...',
    },
    {
        id: 2164261326,
        label: '效果 > 3D 和素材 > 迴轉...',
        placement: 'MenuBar',
        name: '迴轉...',
    },
    {
        id: 2164261327,
        label: '效果 > 3D 和素材 > 膨脹...',
        placement: 'MenuBar',
        name: '膨脹...',
    },
    {
        id: 2164261328,
        label: '效果 > 3D 和素材 > 旋轉...',
        placement: 'MenuBar',
        name: '旋轉...',
    },
    {
        id: 2164261329,
        label: '效果 > 3D 和素材 > 素材...',
        placement: 'MenuBar',
        name: '素材...',
    },
    {
        id: 2164261331,
        label: '效果 > 3D 和素材 > 3D (經典) > 突出與斜角 (經典)...',
        placement: 'MenuBar',
        name: '突出與斜角 (經典)...',
    },
    {
        id: 2164261332,
        label: '效果 > 3D 和素材 > 3D (經典) > 迴轉 (經典)...',
        placement: 'MenuBar',
        name: '迴轉 (經典)...',
    },
    {
        id: 2164261333,
        label: '效果 > 3D 和素材 > 3D (經典) > 旋轉 (經典)...',
        placement: 'MenuBar',
        name: '旋轉 (經典)...',
    },
    {
        id: 2164261334,
        label: '視窗 > SVG 互動',
        placement: 'MenuBar',
        name: 'SVG 互動',
    },
    {
        id: 2164261335,
        label: '物件 > 裁切影像',
        placement: 'MenuBar',
        name: '裁切影像',
    },
    {
        id: 2164261336,
        label: '視窗 > 變數',
        placement: 'MenuBar',
        name: '變數',
    },
    {
        id: 2164261338,
        label: '視窗 > 魔術棒',
        placement: 'MenuBar',
        name: '魔術棒',
    },
    {
        id: 2164261339,
        label: '物件 > 路徑 > 分割下方物件',
        placement: 'MenuBar',
        name: '分割下方物件',
    },
    {
        id: 2164261340,
        label: '選取 > 物件 > 毛刷筆刷筆畫',
        placement: 'MenuBar',
        name: '毛刷筆刷筆畫',
    },
    {
        id: 2164261342,
        label: '物件 > 變形 > 重設邊框',
        placement: 'MenuBar',
        name: '重設邊框',
    },
    {
        id: 2164261343,
        label: '檢視 > 隱藏邊框',
        placement: 'MenuBar',
        name: '隱藏邊框',
    },
    {
        id: 2164261344,
        label: '物件 > 排列順序 > 傳送至目前的圖層',
        placement: 'MenuBar',
        name: '傳送至目前的圖層',
    },
    {
        id: 2164261346,
        label: '物件 > 鎖定 > 上方所有圖稿',
        placement: 'MenuBar',
        name: '上方所有圖稿',
    },
    {
        id: 2164261347,
        label: '物件 > 鎖定 > 其他圖層',
        placement: 'MenuBar',
        name: '其他圖層',
    },
    {
        id: 2164261348,
        label: '物件 > 隱藏 > 上方所有圖稿',
        placement: 'MenuBar',
        name: '上方所有圖稿',
    },
    {
        id: 2164261349,
        label: '物件 > 隱藏 > 其他圖層',
        placement: 'MenuBar',
        name: '其他圖層',
    },
    {
        id: 2164261350,
        label: '選取 > 物件 > 同一圖層上的所有圖稿',
        placement: 'MenuBar',
        name: '同一圖層上的所有圖稿',
    },
    {
        id: 2164261351,
        label: '選取 > 物件 > 方向控制點',
        placement: 'MenuBar',
        name: '方向控制點',
    },
    {
        id: 2164261354,
        label: '選取 > 上方的下一個物件',
        placement: 'MenuBar',
        name: '上方的下一個物件',
    },
    {
        id: 2164261355,
        label: '選取 > 下方的下一個物件',
        placement: 'MenuBar',
        name: '下方的下一個物件',
    },
    {
        id: 2164261358,
        label: '選取 > 儲存選取範圍...',
        placement: 'MenuBar',
        name: '儲存選取範圍...',
    },
    {
        id: 2164261359,
        label: '選取 > 編輯選取範圍...',
        placement: 'MenuBar',
        name: '編輯選取範圍...',
    },
    {
        id: 2164261360,
        label: '選取 > 更新選取範圍',
        placement: 'MenuBar',
        name: '更新選取範圍',
    },
    {
        id: 2164261361,
        label: '物件 > 路徑 > 簡化...',
        placement: 'MenuBar',
        name: '簡化...',
    },
    {
        id: 2164261362,
        label: '物件 > 路徑 > 平滑…',
        placement: 'MenuBar',
        name: '平滑…',
    },
    {
        id: 2164261364,
        label: '物件 > 模型 > 預覽模型',
        placement: 'MenuBar',
        name: '預覽模型',
    },
    {
        id: 2164261365,
        label: '物件 > 模型 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261366,
        label: '物件 > 模型 > 編輯',
        placement: 'MenuBar',
        name: '編輯',
    },
    {
        id: 2164261367,
        label: '效果 > 扭曲與變形 > 螺旋...',
        placement: 'MenuBar',
        name: '螺旋...',
    },
    {
        id: 2164261371,
        label: '檔案 > 指令檔 > 其它指令...',
        placement: 'MenuBar',
        name: '其它指令...',
    },
    {
        id: 2164261372,
        label: '視窗 > CSS 屬性 (已淘汰)',
        placement: 'MenuBar',
        name: 'CSS 屬性 (已淘汰)',
    },
    {
        id: 2164261374,
        label: '效果 > 路徑 > 外框物件',
        placement: 'MenuBar',
        name: '外框物件',
    },
    {
        id: 2164261375,
        label: '視窗 > 顏色',
        placement: 'MenuBar',
        name: '顏色',
    },
    {
        id: 2164261377,
        label: '視窗 > 漸層',
        placement: 'MenuBar',
        name: '漸層',
    },
    {
        id: 2164261378,
        label: '視窗 > 筆畫',
        placement: 'MenuBar',
        name: '筆畫',
    },
    {
        id: 2164261379,
        label: '檢視 > 隱藏漸層註解者',
        placement: 'MenuBar',
        name: '隱藏漸層註解者',
    },
    {
        id: 2164261380,
        label: '物件 > 路徑 > 反轉路徑方向',
        placement: 'MenuBar',
        name: '反轉路徑方向',
    },
    {
        id: 2164261381,
        label: '視窗 > 透明度',
        placement: 'MenuBar',
        name: '透明度',
    },
    {
        id: 2164261382,
        label: '檢視 > 顯示透明度格點',
        placement: 'MenuBar',
        name: '顯示透明度格點',
    },
    {
        id: 2164261383,
        label: '視窗 > 色票',
        placement: 'MenuBar',
        name: '色票',
    },
    {
        id: 2164261386,
        label: '視窗 > 圖樣選項',
        placement: 'MenuBar',
        name: '圖樣選項',
    },
    {
        id: 2164261387,
        label: '視窗 > 產生圖樣 (Beta)',
        placement: 'MenuBar',
        name: '產生圖樣 (Beta)',
    },
    {
        id: 2164261389,
        label: '物件 > 圖樣 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261391,
        label: '物件 > 圖樣 > 編輯圖樣',
        placement: 'MenuBar',
        name: '編輯圖樣',
    },
    {
        id: 2164261392,
        label: '物件 > 圖樣 > 拼貼邊緣顏色...',
        placement: 'MenuBar',
        name: '拼貼邊緣顏色...',
    },
    {
        id: 2164261394,
        label: '物件 > 圖樣 > 產生圖樣 (Beta)',
        placement: 'MenuBar',
        name: '產生圖樣 (Beta)',
    },
    {
        id: 2164261395,
        label: '視窗 > 色票資料庫 > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261396,
        label: '視窗 > 色票資料庫 > 中性',
        placement: 'MenuBar',
        name: '中性',
    },
    {
        id: 2164261397,
        label: '視窗 > 色票資料庫 > 公司',
        placement: 'MenuBar',
        name: '公司',
    },
    {
        id: 2164261400,
        label: '視窗 > 色票資料庫 > 圖樣 > 基本圖樣 > 基本圖樣_直線',
        placement: 'MenuBar',
        name: '基本圖樣_直線',
    },
    {
        id: 2164261401,
        label: '視窗 > 色票資料庫 > 圖樣 > 基本圖樣 > 基本圖樣_紋理',
        placement: 'MenuBar',
        name: '基本圖樣_紋理',
    },
    {
        id: 2164261402,
        label: '視窗 > 色票資料庫 > 圖樣 > 基本圖樣 > 基本圖樣_點',
        placement: 'MenuBar',
        name: '基本圖樣_點',
    },
    {
        id: 2164261404,
        label: '視窗 > 色票資料庫 > 圖樣 > 自然 > 自然_動物毛皮',
        placement: 'MenuBar',
        name: '自然_動物毛皮',
    },
    {
        id: 2164261405,
        label: '視窗 > 色票資料庫 > 圖樣 > 自然 > 自然_葉子',
        placement: 'MenuBar',
        name: '自然_葉子',
    },
    {
        id: 2164261407,
        label: '視窗 > 色票資料庫 > 圖樣 > 裝飾 > Vonster 圖樣',
        placement: 'MenuBar',
        name: 'Vonster 圖樣',
    },
    {
        id: 2164261408,
        label: '視窗 > 色票資料庫 > 圖樣 > 裝飾 > 裝飾舊版',
        placement: 'MenuBar',
        name: '裝飾舊版',
    },
    {
        id: 2164261409,
        label: '視窗 > 色票資料庫 > 大地色調',
        placement: 'MenuBar',
        name: '大地色調',
    },
    {
        id: 2164261410,
        label: '視窗 > 色票資料庫 > 小孩物品',
        placement: 'MenuBar',
        name: '小孩物品',
    },
    {
        id: 2164261411,
        label: '視窗 > 色票資料庫 > 慶祝',
        placement: 'MenuBar',
        name: '慶祝',
    },
    {
        id: 2164261413,
        label: '視窗 > 色票資料庫 > 漸層 > 中性',
        placement: 'MenuBar',
        name: '中性',
    },
    {
        id: 2164261414,
        label: '視窗 > 色票資料庫 > 漸層 > 光亮',
        placement: 'MenuBar',
        name: '光亮',
    },
    {
        id: 2164261415,
        label: '視窗 > 色票資料庫 > 漸層 > 光譜',
        placement: 'MenuBar',
        name: '光譜',
    },
    {
        id: 2164261416,
        label: '視窗 > 色票資料庫 > 漸層 > 協調色彩',
        placement: 'MenuBar',
        name: '協調色彩',
    },
    {
        id: 2164261417,
        label: '視窗 > 色票資料庫 > 漸層 > 大地色調',
        placement: 'MenuBar',
        name: '大地色調',
    },
    {
        id: 2164261418,
        label: '視窗 > 色票資料庫 > 漸層 > 天空',
        placement: 'MenuBar',
        name: '天空',
    },
    {
        id: 2164261419,
        label: '視窗 > 色票資料庫 > 漸層 > 季節',
        placement: 'MenuBar',
        name: '季節',
    },
    {
        id: 2164261420,
        label: '視窗 > 色票資料庫 > 漸層 > 寶石和首飾',
        placement: 'MenuBar',
        name: '寶石和首飾',
    },
    {
        id: 2164261421,
        label: '視窗 > 色票資料庫 > 漸層 > 彩筆',
        placement: 'MenuBar',
        name: '彩筆',
    },
    {
        id: 2164261422,
        label: '視窗 > 色票資料庫 > 漸層 > 暈映',
        placement: 'MenuBar',
        name: '暈映',
    },
    {
        id: 2164261423,
        label: '視窗 > 色票資料庫 > 漸層 > 木紋',
        placement: 'MenuBar',
        name: '木紋',
    },
    {
        id: 2164261424,
        label: '視窗 > 色票資料庫 > 漸層 > 水',
        placement: 'MenuBar',
        name: '水',
    },
    {
        id: 2164261425,
        label: '視窗 > 色票資料庫 > 漸層 > 水果和蔬菜',
        placement: 'MenuBar',
        name: '水果和蔬菜',
    },
    {
        id: 2164261426,
        label: '視窗 > 色票資料庫 > 漸層 > 淡化',
        placement: 'MenuBar',
        name: '淡化',
    },
    {
        id: 2164261427,
        label: '視窗 > 色票資料庫 > 漸層 > 磚石',
        placement: 'MenuBar',
        name: '磚石',
    },
    {
        id: 2164261428,
        label: '視窗 > 色票資料庫 > 漸層 > 簡單輻射',
        placement: 'MenuBar',
        name: '簡單輻射',
    },
    {
        id: 2164261429,
        label: '視窗 > 色票資料庫 > 漸層 > 膚色',
        placement: 'MenuBar',
        name: '膚色',
    },
    {
        id: 2164261430,
        label: '視窗 > 色票資料庫 > 漸層 > 色彩組合',
        placement: 'MenuBar',
        name: '色彩組合',
    },
    {
        id: 2164261431,
        label: '視窗 > 色票資料庫 > 漸層 > 色調及陰影',
        placement: 'MenuBar',
        name: '色調及陰影',
    },
    {
        id: 2164261432,
        label: '視窗 > 色票資料庫 > 漸層 > 葉子',
        placement: 'MenuBar',
        name: '葉子',
    },
    {
        id: 2164261433,
        label: '視窗 > 色票資料庫 > 漸層 > 金屬效果',
        placement: 'MenuBar',
        name: '金屬效果',
    },
    {
        id: 2164261435,
        label: '視窗 > 色票資料庫 > 科學 > 三色',
        placement: 'MenuBar',
        name: '三色',
    },
    {
        id: 2164261436,
        label: '視窗 > 色票資料庫 > 科學 > 互補色',
        placement: 'MenuBar',
        name: '互補色',
    },
    {
        id: 2164261437,
        label: '視窗 > 色票資料庫 > 科學 > 分割互補色',
        placement: 'MenuBar',
        name: '分割互補色',
    },
    {
        id: 2164261438,
        label: '視窗 > 色票資料庫 > 科學 > 四色',
        placement: 'MenuBar',
        name: '四色',
    },
    {
        id: 2164261439,
        label: '視窗 > 色票資料庫 > 科學 > 類似色',
        placement: 'MenuBar',
        name: '類似色',
    },
    {
        id: 2164261440,
        label: '視窗 > 色票資料庫 > 系統 (Macintosh)',
        placement: 'MenuBar',
        name: '系統 (Macintosh)',
    },
    {
        id: 2164261441,
        label: '視窗 > 色票資料庫 > 系統 (Windows)',
        placement: 'MenuBar',
        name: '系統 (Windows)',
    },
    {
        id: 2164261442,
        label: '視窗 > 色票資料庫 > 紡織品',
        placement: 'MenuBar',
        name: '紡織品',
    },
    {
        id: 2164261443,
        label: '視窗 > 色票資料庫 > 網頁',
        placement: 'MenuBar',
        name: '網頁',
    },
    {
        id: 2164261444,
        label: '視窗 > 色票資料庫 > 膚色',
        placement: 'MenuBar',
        name: '膚色',
    },
    {
        id: 2164261446,
        label: '視窗 > 色票資料庫 > 自然 > 季節',
        placement: 'MenuBar',
        name: '季節',
    },
    {
        id: 2164261447,
        label: '視窗 > 色票資料庫 > 自然 > 海灘',
        placement: 'MenuBar',
        name: '海灘',
    },
    {
        id: 2164261448,
        label: '視窗 > 色票資料庫 > 自然 > 磚石',
        placement: 'MenuBar',
        name: '磚石',
    },
    {
        id: 2164261449,
        label: '視窗 > 色票資料庫 > 自然 > 花朵',
        placement: 'MenuBar',
        name: '花朵',
    },
    {
        id: 2164261450,
        label: '視窗 > 色票資料庫 > 自然 > 葉子',
        placement: 'MenuBar',
        name: '葉子',
    },
    {
        id: 2164261451,
        label: '視窗 > 色票資料庫 > 自然 > 風景',
        placement: 'MenuBar',
        name: '風景',
    },
    {
        id: 2164261453,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 亮色',
        placement: 'MenuBar',
        name: '亮色',
    },
    {
        id: 2164261454,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 冷色',
        placement: 'MenuBar',
        name: '冷色',
    },
    {
        id: 2164261455,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 去除飽和度',
        placement: 'MenuBar',
        name: '去除飽和度',
    },
    {
        id: 2164261456,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 暖色',
        placement: 'MenuBar',
        name: '暖色',
    },
    {
        id: 2164261457,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 柔和色',
        placement: 'MenuBar',
        name: '柔和色',
    },
    {
        id: 2164261458,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 深色',
        placement: 'MenuBar',
        name: '深色',
    },
    {
        id: 2164261459,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 淺色',
        placement: 'MenuBar',
        name: '淺色',
    },
    {
        id: 2164261460,
        label: '視窗 > 色票資料庫 > 色彩屬性 > 飽和色',
        placement: 'MenuBar',
        name: '飽和色',
    },
    {
        id: 2164261462,
        label: '視窗 > 色票資料庫 > 色表 > ANPA Color',
        placement: 'MenuBar',
        name: 'ANPA Color',
    },
    {
        id: 2164261463,
        label: '視窗 > 色票資料庫 > 色表 > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261464,
        label: '視窗 > 色票資料庫 > 色表 > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261465,
        label: '視窗 > 色票資料庫 > 色表 > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261466,
        label: '視窗 > 色票資料庫 > 色表 > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261467,
        label: '視窗 > 色票資料庫 > 色表 > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261468,
        label: '視窗 > 色票資料庫 > 色表 > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261469,
        label: '視窗 > 色票資料庫 > 色表 > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261470,
        label: '視窗 > 色票資料庫 > 色表 > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261471,
        label: '視窗 > 色票資料庫 > 色表 > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261472,
        label: '視窗 > 色票資料庫 > 色表 > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261473,
        label: '視窗 > 色票資料庫 > 色表 > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261474,
        label: '視窗 > 色票資料庫 > 色表 > TOYO Color Finder',
        placement: 'MenuBar',
        name: 'TOYO Color Finder',
    },
    {
        id: 2164261475,
        label: '視窗 > 色票資料庫 > 色表 > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261477,
        label: '視窗 > 色票資料庫 > 藝術史 > 中世紀風格',
        placement: 'MenuBar',
        name: '中世紀風格',
    },
    {
        id: 2164261478,
        label: '視窗 > 色票資料庫 > 藝術史 > 俄國海報藝術風格',
        placement: 'MenuBar',
        name: '俄國海報藝術風格',
    },
    {
        id: 2164261479,
        label: '視窗 > 色票資料庫 > 藝術史 > 印象主義風格',
        placement: 'MenuBar',
        name: '印象主義風格',
    },
    {
        id: 2164261480,
        label: '視窗 > 色票資料庫 > 藝術史 > 史前風格',
        placement: 'MenuBar',
        name: '史前風格',
    },
    {
        id: 2164261481,
        label: '視窗 > 色票資料庫 > 藝術史 > 巴洛克風格',
        placement: 'MenuBar',
        name: '巴洛克風格',
    },
    {
        id: 2164261482,
        label: '視窗 > 色票資料庫 > 藝術史 > 文藝復興風格',
        placement: 'MenuBar',
        name: '文藝復興風格',
    },
    {
        id: 2164261483,
        label: '視窗 > 色票資料庫 > 藝術史 > 流行藝術風格',
        placement: 'MenuBar',
        name: '流行藝術風格',
    },
    {
        id: 2164261484,
        label: '視窗 > 色票資料庫 > 藝術史 > 遠古風格',
        placement: 'MenuBar',
        name: '遠古風格',
    },
    {
        id: 2164261485,
        label: '視窗 > 色票資料庫 > 金屬效果',
        placement: 'MenuBar',
        name: '金屬效果',
    },
    {
        id: 2164261487,
        label: '視窗 > 色票資料庫 > 預設色票 > 列印',
        placement: 'MenuBar',
        name: '列印',
    },
    {
        id: 2164261488,
        label: '視窗 > 色票資料庫 > 預設色票 > 基本 RGB',
        placement: 'MenuBar',
        name: '基本 RGB',
    },
    {
        id: 2164261489,
        label: '視窗 > 色票資料庫 > 預設色票 > 網頁',
        placement: 'MenuBar',
        name: '網頁',
    },
    {
        id: 2164261490,
        label: '視窗 > 色票資料庫 > 預設色票 > 裝置',
        placement: 'MenuBar',
        name: '裝置',
    },
    {
        id: 2164261491,
        label: '視窗 > 色票資料庫 > 預設色票 > 視訊和影片',
        placement: 'MenuBar',
        name: '視訊和影片',
    },
    {
        id: 2164261493,
        label: '視窗 > 色票資料庫 > 食物 > 冰淇淋',
        placement: 'MenuBar',
        name: '冰淇淋',
    },
    {
        id: 2164261494,
        label: '視窗 > 色票資料庫 > 食物 > 水果',
        placement: 'MenuBar',
        name: '水果',
    },
    {
        id: 2164261495,
        label: '視窗 > 色票資料庫 > 食物 > 糖果',
        placement: 'MenuBar',
        name: '糖果',
    },
    {
        id: 2164261496,
        label: '視窗 > 色票資料庫 > 食物 > 蔬果',
        placement: 'MenuBar',
        name: '蔬果',
    },
    {
        id: 2164261497,
        label: '視窗 > 色票資料庫 > 食物 > 飲料',
        placement: 'MenuBar',
        name: '飲料',
    },
    {
        id: 2164261500,
        label: '視窗 > 色票資料庫 > 其它資料庫...',
        placement: 'MenuBar',
        name: '其它資料庫...',
    },
    {
        id: 2164261501,
        label: '視窗 > 色彩參考',
        placement: 'MenuBar',
        name: '色彩參考',
    },
    {
        id: 2164261502,
        label: '編輯 > 編輯色彩 > 重新上色圖稿...',
        placement: 'MenuBar',
        name: '重新上色圖稿...',
    },
    {
        id: 2164261505,
        label: '編輯 > 編輯色彩 > 生成式重新上色',
        placement: 'MenuBar',
        name: '生成式重新上色',
    },
    {
        id: 2164261507,
        label: '編輯 > 編輯色彩 > 以預設集重新上色 > 色彩資料庫...',
        placement: 'MenuBar',
        name: '色彩資料庫...',
    },
    {
        id: 2164261508,
        label: '編輯 > 編輯色彩 > 以預設集重新上色 > 單色',
        placement: 'MenuBar',
        name: '單色',
    },
    {
        id: 2164261509,
        label: '編輯 > 編輯色彩 > 以預設集重新上色 > 雙色',
        placement: 'MenuBar',
        name: '雙色',
    },
    {
        id: 2164261510,
        label: '編輯 > 編輯色彩 > 以預設集重新上色 > 三色',
        placement: 'MenuBar',
        name: '三色',
    },
    {
        id: 2164261511,
        label: '編輯 > 編輯色彩 > 以預設集重新上色 > 色彩調和',
        placement: 'MenuBar',
        name: '色彩調和',
    },
    {
        id: 2164261512,
        label: '視窗 > 控制',
        placement: 'MenuBar',
        name: '控制',
    },
    {
        id: 2164261513,
        label: '視窗 > 相關工作列',
        placement: 'MenuBar',
        name: '相關工作列',
    },
    {
        id: 2164261515,
        label: '物件 > 交織 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261516,
        label: '物件 > 交織 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261517,
        label: '物件 > 交織 > 編輯',
        placement: 'MenuBar',
        name: '編輯',
    },
    {
        id: 2164261518,
        label: '視窗 > 對齊',
        placement: 'MenuBar',
        name: '對齊',
    },
    {
        id: 2164261520,
        label: '物件 > 對齊 > 水平齊左',
        placement: 'MenuBar',
        name: '水平齊左',
    },
    {
        id: 2164261521,
        label: '物件 > 對齊 > 水平居中',
        placement: 'MenuBar',
        name: '水平居中',
    },
    {
        id: 2164261522,
        label: '物件 > 對齊 > 水平齊右',
        placement: 'MenuBar',
        name: '水平齊右',
    },
    {
        id: 2164261523,
        label: '物件 > 對齊 > 垂直靠上',
        placement: 'MenuBar',
        name: '垂直靠上',
    },
    {
        id: 2164261524,
        label: '物件 > 對齊 > 垂直居中',
        placement: 'MenuBar',
        name: '垂直居中',
    },
    {
        id: 2164261525,
        label: '物件 > 對齊 > 垂直靠下',
        placement: 'MenuBar',
        name: '垂直靠下',
    },
    {
        id: 2164261527,
        label: '物件 > 均分 > 垂直依上緣均分',
        placement: 'MenuBar',
        name: '垂直依上緣均分',
    },
    {
        id: 2164261528,
        label: '物件 > 均分 > 垂直依中線均分',
        placement: 'MenuBar',
        name: '垂直依中線均分',
    },
    {
        id: 2164261529,
        label: '物件 > 均分 > 垂直依下緣均分',
        placement: 'MenuBar',
        name: '垂直依下緣均分',
    },
    {
        id: 2164261530,
        label: '物件 > 均分 > 水平依左緣均分',
        placement: 'MenuBar',
        name: '水平依左緣均分',
    },
    {
        id: 2164261531,
        label: '物件 > 均分 > 水平依中線均分',
        placement: 'MenuBar',
        name: '水平依中線均分',
    },
    {
        id: 2164261532,
        label: '物件 > 均分 > 水平依右緣均分',
        placement: 'MenuBar',
        name: '水平依右緣均分',
    },
    {
        id: 2164261533,
        label: '視窗 > 變形',
        placement: 'MenuBar',
        name: '變形',
    },
    {
        id: 2164261534,
        label: '檢視 > 隱藏尖角 Widget',
        placement: 'MenuBar',
        name: '隱藏尖角 Widget',
    },
    {
        id: 2164261536,
        label: '物件 > 重複 > 放射狀',
        placement: 'MenuBar',
        name: '放射狀',
    },
    {
        id: 2164261537,
        label: '物件 > 重複 > 格點',
        placement: 'MenuBar',
        name: '格點',
    },
    {
        id: 2164261538,
        label: '物件 > 重複 > 鏡像',
        placement: 'MenuBar',
        name: '鏡像',
    },
    {
        id: 2164261540,
        label: '物件 > 重複 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261541,
        label: '物件 > 重複 > 選項...',
        placement: 'MenuBar',
        name: '選項...',
    },
    {
        id: 2164261543,
        label: '物件 > 路徑物件 > 附加…',
        placement: 'MenuBar',
        name: '附加…',
    },
    {
        id: 2164261544,
        label: '物件 > 路徑物件 > 選項...',
        placement: 'MenuBar',
        name: '選項...',
    },
    {
        id: 2164261545,
        label: '物件 > 路徑物件 > 展開',
        placement: 'MenuBar',
        name: '展開',
    },
    {
        id: 2164261546,
        label: '效果 > 路徑 > 外框筆畫',
        placement: 'MenuBar',
        name: '外框筆畫',
    },
    {
        id: 2164261547,
        label: '效果 > 路徑 > 位移複製...',
        placement: 'MenuBar',
        name: '位移複製...',
    },
    {
        id: 2164261548,
        label: '物件 > 路徑 > 外框筆畫',
        placement: 'MenuBar',
        name: '外框筆畫',
    },
    {
        id: 2164261549,
        label: '物件 > 路徑 > 位移複製...',
        placement: 'MenuBar',
        name: '位移複製...',
    },
    {
        id: 2164261551,
        label: '視窗 > 工具列 > 基本',
        placement: 'MenuBar',
        name: '基本',
    },
    {
        id: 2164261552,
        label: '視窗 > 工具列 > 進階',
        placement: 'MenuBar',
        name: '進階',
    },
    {
        id: 2164261553,
        label: '視窗 > 工具列 > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261555,
        label: '視窗 > 工具列 > 新增工具列...',
        placement: 'MenuBar',
        name: '新增工具列...',
    },
    {
        id: 2164261556,
        label: '視窗 > 工具列 > 管理工具列...',
        placement: 'MenuBar',
        name: '管理工具列...',
    },
    {
        id: 2164261557,
        label: '視窗 > 屬性',
        placement: 'MenuBar',
        name: '屬性',
    },
    {
        id: 2164261558,
        label: '文字 > Adobe Fonts 提供更多字體與功能...',
        placement: 'MenuBar',
        name: 'Adobe Fonts 提供更多字體與功能...',
    },
    {
        id: 2164261559,
        label: '文字 > 解決遺失字體...',
        placement: 'MenuBar',
        name: '解決遺失字體...',
    },
    {
        id: 2164261560,
        label: '說明 > 支援社群',
        placement: 'MenuBar',
        name: '支援社群',
    },
    {
        id: 2164261561,
        label: '說明 > 提交錯誤/功能要求...',
        placement: 'MenuBar',
        name: '提交錯誤/功能要求...',
    },
    {
        id: 2164261563,
        label: '物件 > 製作像素級最佳化',
        placement: 'MenuBar',
        name: '製作像素級最佳化',
    },
    {
        id: 2164261564,
        label: '視窗 > 文字 > 重排檢視器',
        placement: 'MenuBar',
        name: '重排檢視器',
    },
    {
        id: 2164261565,
        label: '說明 > 生成式 AI 使用者原則',
        placement: 'MenuBar',
        name: '生成式 AI 使用者原則',
    },
    {
        id: 2164261567,
        label: '編輯 > 列印預設集...',
        placement: 'MenuBar',
        name: '列印預設集...',
    },
    {
        id: 2164261569,
        label: '檔案 > 列印...',
        placement: 'MenuBar',
        name: '列印...',
    },
    {
        id: 2164261570,
        label: '編輯 > 透明度平面化預設集...',
        placement: 'MenuBar',
        name: '透明度平面化預設集...',
    },
    {
        id: 2164261571,
        label: '物件 > 透明度平面化...',
        placement: 'MenuBar',
        name: '透明度平面化...',
    },
    {
        id: 2164261573,
        label: '物件 > 形狀 > 轉換為形狀',
        placement: 'MenuBar',
        name: '轉換為形狀',
    },
    {
        id: 2164261574,
        label: '物件 > 形狀 > 展開形狀',
        placement: 'MenuBar',
        name: '展開形狀',
    },
    {
        id: 2164261575,
        label: '視窗 > 模型',
        placement: 'MenuBar',
        name: '模型',
    },
    {
        id: 2164261576,
        label: '視窗 > 產生的變化版本',
        placement: 'MenuBar',
        name: '產生的變化版本',
    },
    {
        id: 2164261577,
        label: '物件 > 產生向量 (Beta)…',
        placement: 'MenuBar',
        name: '產生向量 (Beta)…',
    },
    {
        id: 2164261578,
        label: '檔案 > 產生向量 (Beta)…',
        placement: 'MenuBar',
        name: '產生向量 (Beta)…',
    },
    {
        id: 2164261579,
        label: '物件 > 生成式形狀填色 (Beta)…',
        placement: 'MenuBar',
        name: '生成式形狀填色 (Beta)…',
    },
    {
        id: 2164261580,
        label: '視窗 > 3D 和素材',
        placement: 'MenuBar',
        name: '3D 和素材',
    },
    {
        id: 2164261582,
        label: '物件 > 透視 > 附加至作用中的平面',
        placement: 'MenuBar',
        name: '附加至作用中的平面',
    },
    {
        id: 2164261583,
        label: '物件 > 透視 > 隨透視釋放',
        placement: 'MenuBar',
        name: '隨透視釋放',
    },
    {
        id: 2164261584,
        label: '物件 > 透視 > 移動平面以符合物件',
        placement: 'MenuBar',
        name: '移動平面以符合物件',
    },
    {
        id: 2164261585,
        label: '物件 > 透視 > 編輯文字',
        placement: 'MenuBar',
        name: '編輯文字',
    },
    {
        id: 2164261586,
        label: '編輯 > 透視格點預設集...',
        placement: 'MenuBar',
        name: '透視格點預設集...',
    },
    {
        id: 2164261589,
        label: '檢視 > 透視格點 > 顯示格點',
        placement: 'MenuBar',
        name: '顯示格點',
    },
    {
        id: 2164261590,
        label: '檢視 > 透視格點 > 顯示尺標',
        placement: 'MenuBar',
        name: '顯示尺標',
    },
    {
        id: 2164261591,
        label: '檢視 > 透視格點 > 靠齊格點',
        placement: 'MenuBar',
        name: '靠齊格點',
    },
    {
        id: 2164261592,
        label: '檢視 > 透視格點 > 鎖定格點',
        placement: 'MenuBar',
        name: '鎖定格點',
    },
    {
        id: 2164261593,
        label: '檢視 > 透視格點 > 鎖定站點',
        placement: 'MenuBar',
        name: '鎖定站點',
    },
    {
        id: 2164261595,
        label: '檢視 > 透視格點 > 定義格點...',
        placement: 'MenuBar',
        name: '定義格點...',
    },
    {
        id: 2164261601,
        label: '檢視 > 透視格點 > 將格點另存為預設集...',
        placement: 'MenuBar',
        name: '將格點另存為預設集...',
    },
    {
        id: 2164261602,
        label: '視窗 > 影像描圖',
        placement: 'MenuBar',
        name: '影像描圖',
    },
    {
        id: 2164261604,
        label: '物件 > 影像描圖 > 製作',
        placement: 'MenuBar',
        name: '製作',
    },
    {
        id: 2164261605,
        label: '物件 > 影像描圖 > 製作並展開',
        placement: 'MenuBar',
        name: '製作並展開',
    },
    {
        id: 2164261606,
        label: '物件 > 影像描圖 > 釋放',
        placement: 'MenuBar',
        name: '釋放',
    },
    {
        id: 2164261608,
        label: '物件 > 影像描圖 > 展開',
        placement: 'MenuBar',
        name: '展開',
    },
    {
        id: 2164261609,
        label: '效果 > 模糊 > 高斯模糊...',
        placement: 'MenuBar',
        name: '高斯模糊...',
    },
    {
        id: 2164261610,
        label: '編輯 > Adobe PDF 預設集...',
        placement: 'MenuBar',
        name: 'Adobe PDF 預設集...',
    },
    {
        id: 2164261611,
        label: '視窗 > 資產轉存',
        placement: 'MenuBar',
        name: '資產轉存',
    },
    {
        id: 2164261612,
        label: '檔案 > 邀請參與編輯...',
        placement: 'MenuBar',
        name: '邀請參與編輯...',
    },
    {
        id: 2164261613,
        label: '檔案 > 共用以供審核...',
        placement: 'MenuBar',
        name: '共用以供審核...',
    },
    {
        id: 2164261614,
        label: '檢視 > 透視格點 > 單點透視 > [單點-一般檢視]',
        placement: 'MenuBar',
        name: '[單點-一般檢視]',
    },
    {
        id: 2164261615,
        label: '檢視 > 透視格點 > 兩點透視 > [兩點-一般檢視]',
        placement: 'MenuBar',
        name: '[兩點-一般檢視]',
    },
    {
        id: 2164261616,
        label: '檢視 > 透視格點 > 三點透視 > [三點-一般檢視]',
        placement: 'MenuBar',
        name: '[三點-一般檢視]',
    },
    {
        id: 2164261619,
        label: '視窗 > 延伸功能 > 資料庫',
        placement: 'MenuBar',
        name: '資料庫',
    },
    {
        id: 2164261620,
        label: '視窗 > 版本記錄',
        placement: 'MenuBar',
        name: '版本記錄',
    },
    {
        id: 2164261621,
        label: '檔案 > 版本記錄',
        placement: 'MenuBar',
        name: '版本記錄',
    },
    {
        id: 2164261622,
        label: '視窗 > 註解',
        placement: 'MenuBar',
        name: '註解',
    },
    {
        id: 'Adobe Scroll Tool',
        label: '手形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: '鋼筆工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: '縮放工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: '旋轉工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: '鏡射工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: '傾斜工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: '剪刀工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: '測量工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: '列印並排工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: '群組選取工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: '直接選取工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: '選取工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: '放大鏡工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: '增加錨點工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: '刪除錨點工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: '錨點工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: '長條圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: '堆疊長條圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: '折線圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: '圓形圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: '區域圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: '散佈圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: '橫條圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: '堆疊橫條圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: '雷達圖工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: '網格工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: '文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: '區域文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: '路徑文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: '垂直文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: '垂直區域文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: '直式路徑文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: '觸控文字工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: '形狀建立程式工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: '即時上色油漆桶',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: '即時上色選取工具',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: '透視格點工具',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: '透視選取工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: '漸變工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: '切片工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: '切片選取範圍工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: '套索工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: '工作區域工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: '曲線工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Shaper 工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: '操控彎曲工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: '魔術棒工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: '美工刀工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: '反光工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: '任意變形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: '線段區段工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: '弧形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: '矩形格線工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: '放射網格工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: '彎曲工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: '扭轉工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: '縮攏工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: '膨脹工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: '扇形化工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: '結晶化工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: '皺摺工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: '快速筆型工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: '鉛筆工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: '繪圖筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: '點滴筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: '平滑工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: '路徑橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: '合併工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: '橢圓形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: '多邊形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: '星形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: '矩形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: '圓角矩形工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: '螺旋工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: '符號噴灑器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: '符號偏移器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: '符號壓縮器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: '符號縮放器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: '符號旋轉器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: '符號著色器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: '符號濾色器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: '符號樣式設定器工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: '漸層工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: '尺寸工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: '路徑物件',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: '旋轉檢視工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: '改變外框工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: '寬度工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: '橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: '檢色滴管工具',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D 和素材',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: '動作',
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: '字符',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: '筆刷',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: '字元樣式',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: '色彩參考',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: '平面化工具預視',
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: '漸層',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: '定位點',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: '圖層',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: '屬性',
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: '段落樣式',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: '屬性',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: '分色預視',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: '色票',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: '變數',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: '定位點',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: '對齊',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: '外觀',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: '工作區域',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: '註解',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'CSS 屬性 (已淘汰)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: '資料庫',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: '字元',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: '顏色',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: '文件資訊',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: '資產轉存',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: '產生的變化版本',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: '歷史記錄',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: '資訊',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: '連結',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: '魔術棒',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: '模型',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: '繪圖樣式',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: '導覽器',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: '路徑管理員',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: '圖樣選項',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: '重排檢視器',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'SVG 互動',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: '筆畫',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: '符號',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: '變形',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: '透明度',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: '影像描圖',
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: '版本記錄',
        placement: 'Panel',
    },
];
